if (typeof EFOLI_INKYBAY_SCRIPTTAG_JS_INIT > "u")
    var EFOLI_INKYBAY_SCRIPTTAG_JS_INIT = [];
if (typeof EFOLI_INKYBAY_SCRIPTTAG_JS_INIT.INKYBAY > "u") {
    EFOLI_INKYBAY_SCRIPTTAG_JS_INIT.INKYBAY = "6.0.1";
    var customizable_pro_id_arr = ["2870501244992", "3517777641536", "6562206875705"]
      , mobile_header_html = ""
      , inkybayLoaderSvg = '<span style="position:absolute;display:inline-block;min-width:20px;min-height:20px"><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 20 20" style="position:absolute;height:100%;left:-50%;" class="inkybay_animate" aria-label="Loading" role="status"><path fill="currentColor" d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z"><animateTransform attributeName="transform" attributeType="XML" type="rotate" from="0 10 10" to="360 10 10" dur="1s" repeatCount="indefinite"/></path></svg>&nbsp;</span>'
      , inkybayMtime = "1751556487283"
      , _d = document
      , _f = new function() {
        var t = this;
        t.is = function(v) {
            return typeof v < "u"
        }
        ,
        t.isf = function(v) {
            return typeof v == "function"
        }
        ,
        t.isn = function(v) {
            return t.s(v).search("[^0-9.]") == -1
        }
        ,
        t.i = function(v) {
            return parseInt(v)
        }
        ,
        t.n = function(v) {
            return Number(v)
        }
        ,
        t.s = function(v) {
            return String(v)
        }
        ,
        t.rd = function(v) {
            return Math.round(v)
        }
        ,
        t.fl = function(v) {
            return Math.floor(v)
        }
        ,
        t.cl = function(v) {
            return Math.ceil(v)
        }
        ,
        t.sr = function(v) {
            return Math.sqrt(v)
        }
        ,
        t.pw = function(v, w) {
            return Math.pow(v, w)
        }
        ,
        t.mx = function(v, w) {
            return Math.max(v, w)
        }
        ,
        t.mn = function(v, w) {
            return Math.min(v, w)
        }
        ,
        t.rn = function(mn, mx) {
            return t.is(mx) ? t.fl(Math.random() * (mx - mn)) + mn : Math.random()
        }
        ,
        t.s2x = function(s) {
            var x = null;
            if (s = s.replace(/(\r\n|\n|\r)/gm, ""),
            s = s.replace(/>\s*/g, ">"),
            s = s.replace(/\s*</g, "<"),
            _s_WIN._.DOMParser) {
                var p = new DOMParser;
                x = p.parseFromString(s, "text/xml")
            } else
                x = new ActiveXObject("Microsoft.XMLDOM"),
                x.async = !1,
                x.loadXML(s);
            return x
        }
    }
      , _o = new function() {
        var t = this
          , _doc = typeof _d > "u" ? document : _d;
        t.id = function(d, f) {
            return _f.is(f) ? f.querySelector("#" + d) : _doc.getElementById(d)
        }
        ,
        t.cl = function(c, f) {
            return _f.is(f) ? f.querySelectorAll("." + c) : _doc.querySelectorAll("." + c)
        }
        ,
        t.nm = function(n, i2) {
            return _f.is(i2) ? _doc.getElementsByName(n).item(i2) : _doc.getElementsByName(n)
        }
        ,
        t.tg = function(tg, i2) {
            return _f.is(i2) ? _doc.getElementsByTagName(tg).item(i2) : _doc.getElementsByTagName(tg)
        }
        ,
        t.ce = function(tg, i2, c, n) {
            var e = _doc.createElement(tg);
            return _f.is(i2) && (e.id = i2),
            _f.is(c) && (e.className = c),
            _f.is(n) && (e.name = n),
            e
        }
        ,
        t.a = function(o, n, v) {
            o.setAttribute(n, v)
        }
        ,
        t._a = function(o, n) {
            return o.getAttribute ? o.getAttribute(n) : null
        }
        ,
        t.x = function(o) {
            return _f.i(o.offsetLeft)
        }
        ,
        t.y = function(o) {
            return _f.i(o.offsetTop)
        }
        ,
        t.w = function(o) {
            return _f.i(o.offsetWidth)
        }
        ,
        t.h = function(o) {
            return _f.i(o.offsetHeight)
        }
        ,
        t.r = function(o) {
            return [t.x(o), t.y(o), t.w(o), t.h(o)]
        }
        ,
        t.sx = function(o) {
            return _f.n(o.style.left.split("px").join(""))
        }
        ,
        t.sy = function(o) {
            return _f.n(o.style.top.split("px").join(""))
        }
        ,
        t.sw = function(o) {
            return _f.n(o.style.width.split("px").join(""))
        }
        ,
        t.sh = function(o) {
            return _f.n(o.style.height.split("px").join(""))
        }
        ,
        t.sr = function(o) {
            return [t.sx(o), t.sy(o), t.sw(o), t.sh(o)]
        }
        ,
        t.rx = function(o) {
            return t.rr(o)[0]
        }
        ,
        t.ry = function(o) {
            return t.rr(o)[1]
        }
        ,
        t.rw = function(o) {
            return t.rr(o)[2]
        }
        ,
        t.rh = function(o) {
            return t.rr(o)[3]
        }
        ,
        t.rr = function(o) {
            var er = o.getBoundingClientRect()
              , br = _doc.body.getBoundingClientRect();
            return [_f.n(er.left - br.left), _f.n(er.top - br.top), _f.n(er.right - er.left), _f.n(er.bottom - er.top)]
        }
        ,
        t.add = function(o, el_r) {
            for (var i2 = 0; i2 < el_r.length; i2++)
                o.appendChild(el_r[i2])
        }
    }
      , _s_WIN = new function() {
        var t = this
          , _w = t._ = window;
        t.d = document,
        t.w = function() {
            return _w.innerWidth || t.d.documentElement.clientWidth || t.d.body.clientWidth
        }
        ,
        t.h = function() {
            return _w.innerHeight || t.d.documentElement.clientHeight || t.d.body.clientHeight
        }
    }
      , _ib_request = function() {
        var t = this, x;
        try {
            x = new XMLHttpRequest
        } catch {
            try {
                x = new ActiveXObject("Msxml2.XMLHTTP")
            } catch {
                try {
                    x = new ActiveXObject("Microsoft.XMLHTTP")
                } catch {
                    return alert("Not support AJAX!"),
                    !1
                }
            }
        }
        t.p = function(to, p, u) {
            x.open("POST", to, !0),
            x.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            var rndn = _f.rn;
            p += u ? "&SKUPRD_" + _f.rn() + "=" + _f.rn() : "",
            x.send(p)
        }
        ,
        t.pl = function(to, p, f, u) {
            if (_f.isf(f)) {
                for (var a_r = [], i2 = 4; i2 < arguments.length; i2++)
                    a_r.push(arguments[i2]);
                x.onreadystatechange = function() {
                    if (x.readyState == 4) {
                        var r = x.responseText;
                        f(r, a_r)
                    }
                }
                ,
                t.p(to, p, u)
            } else
                console.log("POST AND LOAD ERROR :: Function not found")
        }
        ,
        t.s = function(to, p, u) {
            var nm = to.indexOf("?") == -1
              , qm = nm ? "?" : "&";
            p = p == "" ? "" : qm + p,
            nm = nm ? p == "" : !0;
            var um = nm ? "?" : "&"
              , ur = u ? um + "SKUPRD_" + _f.rn() + "=" + _f.rn() : "";
            x.open("GET", to + p + ur, !0),
            x.send(null)
        }
        ,
        t.sl = function(to, p, f, u) {
            if (_f.isf(f)) {
                for (var a_r = [], i2 = 4; i2 < arguments.length; i2++)
                    a_r.push(arguments[i2]);
                x.onreadystatechange = function() {
                    if (x.readyState == 4)
                        if (x.status == 200) {
                            var r = x.responseText;
                            f(r, a_r)
                        } else
                            console.log(to + " got error : " + x.status)
                }
                ,
                t.s(to, p, u)
            } else
                console.log("SEND AND LOAD ERROR :: Function not found")
        }
        ,
        t.slx = function(to, f, u) {
            for (var a_r = [], i2 = 3; i2 < arguments.length; i2++)
                a_r.push(arguments[i2]);
            var _rxmlfn = function(xd) {
                f(_f.s2x(xd), a_r)
            };
            t.sl(to, "", _rxmlfn, u)
        }
    }
      , _r = new _ib_request
      , firePdesignerInitialized = function() {
        _o.id("firePdesignerInitialized_alt").style.display = "none";
        var pdesigner_cont = _o.id("EFOLI_DESIGNER_ROOT");
        pdesigner_cont.style.border = "0px dotted #CCC"
    }
      , iBwOrigin = window.location.origin
      , ibgctlcr = (window.location + "").split("//").join("").split("/")
      , iBwLocalSlag = "";
    typeof ibgctlcr[1] < "u" && Shopify.locale + "" == ibgctlcr[1].substr(0, 2) && (iBwOrigin = window.location.origin + "/" + ibgctlcr[1],
    iBwLocalSlag = ibgctlcr[1]);
    var selsizestr = "1"
      , showProductsDesignerActionDone = !1
      , showProductsDesigner = function(e) {
        if (!showProductsDesignerActionDone) {
            let btn = e.currentTarget ? e.currentTarget : e;
            changeProQuantity();
            var added_color_url = selectedColor != "" && String(selectedColor) != "undefined" ? "?procol=" + selectedColor : ""
              , added_size_url = added_color_url == "" ? "?szqty=" + selsizestr : "&szqty=" + selsizestr
              , pre_str = btn.innerHTML;
            btn.innerHTML = inkybayLoaderSvg + '<span style="opacity:0.2">' + btn.innerHTML + "</span>",
            btn.style.pointerEvents = "none",
            typeof packInkybayOptionsAndGo == "function" ? (meta.product.id = _f.is(meta.product.productId) ? meta.product.productId : meta.product.id,
            packafterlocation = iBwOrigin + "/pages/designlab/pid-" + meta.product.id + added_color_url + added_size_url,
            packInkybayOptionsAndGo(packafterlocation, btn, pre_str)) : location = iBwOrigin + "/pages/designlab/pid-" + meta.product.id + added_color_url + added_size_url,
            showProductsDesignerActionDone = !0,
            setTimeout( () => {
                showProductsDesignerActionDone = !1
            }
            , 1e3)
        }
    }
      , showProductsDesignerWithTemplate = function(tid2) {
        var tid_r = tid2.split("inkybay_option_id_");
        if (tid2 = tid_r[0],
        _f.is(tid_r[1])) {
            var final_tid = tid2.split("<br>")[0].split(" ")[0]
              , option_id = tid_r[1].split("<br>")[0].split(" ")[0]
              , _rpop = new _ib_request;
            _rpop.pl("https://inkybay.com/shopify/out/usr/get/getProductOptionPrice.php?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798", "oid=" + option_id, showProductsDesignerWithOption, !0, final_tid, option_id)
        } else {
            var final_tid = tid2.split("<br>")[0].split(" ")[0];
            location = iBwOrigin + "/pages/designlab/tid-" + final_tid
        }
    }
      , showProductsDesignerWithOption = function(d, p) {
        var tid2 = p[0]
          , oid = p[1]
          , optprice = d;
        location = iBwOrigin + "/pages/designlab/tid-" + tid2 + "?inkyreorder=y&inkybayoption=" + oid + "|" + optprice
    }
      , efl_Tier_price_type = "PERCENT"
      , efl_Tier_price_for_product = "Y"
      , efl_Tier_price_for_design = "N"
      , efl_Tier_price_for_option = "N"
      , efl_Tier_price_rule = "";
    if (!_o.id("PRODUCTS_DESIGNER_CUSTOMIZE_IT_BUTTON") && typeof meta < "u" && meta.page.pageType == "product") {
        var has_inventory_check = _o.id("INKYBAY_SHOPIFY_PRODUCT_INVENTORY_NEED_CHECK")
          , ibspi_available = has_inventory_check ? _o.id("INKYBAY_SHOPIFY_PRODUCT_INVENTORY_COUNT").innerHTML * 1 : !0
          , ibspi_available_count = has_inventory_check ? 1 * _o.id("INKYBAY_SHOPIFY_PRODUCT_INVENTORY_COUNT").innerHTML : 0;
        meta.product.id = _f.is(meta.product.productId) ? meta.product.productId : meta.product.id;
        var proId = meta.product.id
          , is_customizable = customizable_pro_id_arr.indexOf(String(proId)) != -1;
        _o.id("inkybay_collection_cart_btn_" + proId) && (_o.id("inkybay_collection_cart_btn_" + proId).style.display = "block");
        var tier_price_show = function(customize_btn2) {
            var tier_div = _o.ce("div", "SHOW_TIER_PRICE_DIV");
            tier_div.style.width = "100%",
            tier_div.style.display = "none",
            tier_div.style.height = "auto";
            var before_div = "";
            _o.id("INKYBAY_PRODUCT_OPTION_DIV") ? before_div = _o.id("INKYBAY_PRODUCT_OPTION_DIV") : _o.id("SHOW_SIZE_COLOR_DIV") ? before_div = _o.id("SHOW_SIZE_COLOR_DIV") : before_div = customize_btn2,
            _o.id("INKYBAY_QUANTITY_DISCOUNT_SHOW_DIV") ? _o.id("INKYBAY_QUANTITY_DISCOUNT_SHOW_DIV").appendChild(tier_div) : before_div.parentNode.insertBefore(tier_div, before_div);
            var tcss = "#SHOW_TIER_PRICE_DIV{border:#eee 1px solid; padding:10px;} .SHOW_TIER_PRICE_DIV_ROW{border-bottom:#ccc 1px dotted; color:#333333; padding-bottom:5px;}"
              , thead = document.head || document.getElementsByTagName("head")[0]
              , tstyle = document.createElement("style");
            tstyle.type = "text/css",
            tstyle.styleSheet ? tstyle.styleSheet.cssText = tcss : tstyle.appendChild(document.createTextNode(tcss)),
            thead.appendChild(tstyle);
            var afterloadTierPrice = function(d) {
                var d_r = d.split("|:~TIERPRICERULES~:|")
                  , sd = '<div id="INKYBAY_QUANTITY_DISCOUNT_SHOW_TITLE"><strong>Buy more, Save more</strong></div>';
                tier_div.innerHTML = sd + d_r[0],
                d_r[0] != "" && (tier_div.style.display = "block"),
                efl_Tier_price_type = _f.is(d_r[1]) ? d_r[1] : efl_Tier_price_type,
                efl_Tier_price_rule = _f.is(d_r[2]) ? d_r[2] : efl_Tier_price_rule,
                efl_Tier_price_for_product = _f.is(d_r[3]) ? d_r[3] : efl_Tier_price_for_product,
                efl_Tier_price_for_design = _f.is(d_r[4]) ? d_r[4] : efl_Tier_price_for_design,
                efl_Tier_price_for_option = _f.is(d_r[5]) ? d_r[5] : efl_Tier_price_for_option,
                showInkybayProductCustomPrice()
            }
              , _rdpt = new _ib_request;
            _rdpt.pl("https://inkybay.com/shopify/out/usr/get/showQuantityDiscountPriceTable.php?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798", "proid=" + proId, afterloadTierPrice)
        }
          , ibHideDefaultForm = () => {
            (typeof is_customizable < "u" && is_customizable || typeof hasInkyBayOption < "u" && hasInkyBayOption) && (document.head.insertAdjacentHTML("beforeend", '<style class="INKYBAY_STYLE_FORMS">form[action*="cart/add"]{display:none;}</style>'),
            setTimeout(function() {
                if (_o.id("EFOLI_DESIGNER_CUSTOMIZE_IT_BUTTON_PLACE")) {
                    var mvplace = _o.id("EFOLI_DESIGNER_CUSTOMIZE_IT_BUTTON_PLACE");
                    if (mvplace.offsetParent === null)
                        for (var inkystlFields = _o.cl("INKYBAY_STYLE_FORMS"), cci = 0; cci < inkystlFields.length; cci++)
                            inkystlFields[cci].innerHTML = ""
                }
            }, 200))
        }
        ;
        if (is_customizable && ibspi_available) {
            var cart_btn_form = "NOTFOUND";
            if (console.log("Inkybay : Customizable Product"),
            document.head.insertAdjacentHTML("beforeend", "<style>.inkybay_custom_product_hide_elements{display:none !important;}#EFOLI_APP_INKYBAY_BLOCK_PRODUCT div:empty{display:block;}#EFOLI_CUSTOMIZE_IT_BUTTON div:empty{display:block;}#EFOLI_BUY_BLANK_BUTTON div:empty{display:block;}#SHOW_SIZE_COLOR_DIV div:empty{display:block;}#INKYBAY_PRODUCT_OPTION_DIV div:empty{display:block;}#SHOW_TIER_PRICE_DIV div:empty{display:block;}</style>"),
            document.forms.length == 0)
                cart_btn_form = "NOTFOUND";
            else {
                for (var fi = 0; fi < document.forms.length; fi++) {
                    var frm = document.forms[fi]
                      , frmhidden = frm.offsetParent === null;
                    (frm.hasAttribute("action") && frm.getAttribute("action").indexOf("/cart/add") >= 0 && cart_btn_form == "NOTFOUND" && !frmhidden || frm.getAttribute("inkybayform") == "Y") && (cart_btn_form = frm)
                }
                if (cart_btn_form == "NOTFOUND")
                    for (var fi = 0; fi < document.forms.length; fi++) {
                        var frm = document.forms[fi]
                          , frmhidden = frm.offsetParent === null;
                        frm.getAttribute("action") == iBwOrigin + "/cart/add" && cart_btn_form == "NOTFOUND" && !frmhidden && (cart_btn_form = frm)
                    }
            }
            cart_btn_form == "NOTFOUND" && (_o.id("EFOLI_DESIGNER_CUSTOMIZE_IT_BUTTON_PLACE") || console.log("No space found for customize button"));
            var cart_btn_holder = cart_btn_form
              , clr_div = _o.ce("div");
            clr_div.style.clear = "both",
            clr_div.style.height = "1px",
            clr_div.style.width = "100%";
            var customize_btn = _o.ce("div", "EFOLI_CUSTOMIZE_IT_BUTTON", "btn");
            customize_btn.innerHTML = '<span id="PRODUCTS_DESIGNER_CUSTOMIZE_IT_BUTTON">Customize it</span>';
            var dcss = "#EFOLI_CUSTOMIZE_IT_BUTTON{border:2px;border-radius: 10px;color: #ffffff;background: #3498db;padding: 10px 20px 10px 20px;} #EFOLI_BUY_BLANK_BUTTON{margin-left:2px;border:0px;border-radius: 10px;color: #ffffff;background: #3498db;padding: 10px 20px 10px 20px;}"
              , dhead = document.head || document.getElementsByTagName("head")[0]
              , dstyle = document.createElement("style");
            if (dstyle.type = "text/css",
            dstyle.styleSheet ? dstyle.styleSheet.cssText = dcss : dstyle.appendChild(document.createTextNode(dcss)),
            dhead.appendChild(dstyle),
            _o.a(customize_btn, "onmouseup", "showProductsDesigner(this)"),
            _o.a(customize_btn, "touchstart", "showProductsDesigner(this)"),
            customize_btn.addEventListener("mouseup", showProductsDesigner),
            customize_btn.addEventListener("touchstart", showProductsDesigner),
            _o.id("EFOLI_DESIGNER_CUSTOMIZE_IT_BUTTON_PLACE") ? (cart_btn_holder = _o.id("EFOLI_DESIGNER_CUSTOMIZE_IT_BUTTON_PLACE"),
            _o.add(cart_btn_holder, [clr_div, customize_btn])) : (cart_btn_holder.parentNode.insertBefore(clr_div, cart_btn_holder),
            cart_btn_holder.parentNode.insertBefore(customize_btn, cart_btn_holder)),
            ibHideDefaultForm(),
            0)
                var cs_div, afterloadcs, gprocolor, urlpc, colorBeforeSize, _rsoc;
            else
                tier_price_show(customize_btn)
        }
        var inkybayInvInit = !1
          , inkybayInvData = []
          , inkybayInventorySetup = () => {
            var clrs = document.getElementsByClassName("INKYBAY_COLOR_INVENTORY");
            for (let cli = 0; cli < clrs.length; cli++)
                inkybayInvData[clrs[cli].id] = JSON.parse(clrs[cli].innerHTML);
            if (inkybayInvInit = !0,
            clrs.length > 1) {
                let efl_colorHex2 = _o.id("efl_product_clrselid") ? _o.id("efl_product_clrselid").innerHTML : "";
                distributeInventoryQty(efl_colorHex2)
            } else if (clrs.length == 1) {
                let efl_colorHex2 = _o.id("efl_product_clrselid") ? _o.id("efl_product_clrselid").innerHTML : "";
                efl_colorHex2 = efl_colorHex2 == "" ? "DEFAULT" : efl_colorHex2,
                distributeInventoryQty(efl_colorHex2)
            } else
                distributeInventoryQty("DEFAULT")
        }
          , distributeInventoryQty = clr => {
            if (_o.id("INKYBAY_IS_INVENTORY_TRACK_PRODUCT")) {
                _o.id("INKYBAY_SELECTED_COLOR_ID").innerHTML = clr;
                var invMLbl = "";
                if (_o.id("INKYBAY_INVENTORY_LABEL")) {
                    invMLbl = _o.id("INKYBAY_INVENTORY_LABEL");
                    var invLbl = document.getElementsByClassName("efl_size_qty_inv_box");
                    for (let inli = 0; inli < invLbl.length; inli++)
                        invLbl[inli].innerHTML = _o._a(invMLbl, "fulllabel");
                    var invqbx = document.getElementsByClassName("efl_size_qty_box");
                    for (let inli = 0; inli < invqbx.length; inli++)
                        _o.a(invqbx[inli], "max", 999999999)
                }
                var invD = inkybayInvData["INKYBAY_COLOR_INVENTORY_" + clr];
                for (let invi = 0; invi < invD.length; invi++) {
                    let invk_r = invD[invi].k.split("_");
                    if (invk_r[2] && invk_r[3]) {
                        let inps = document.querySelectorAll('[inventory_mark="' + invk_r[2] + "_" + invk_r[3] + '"]');
                        for (let inpi = 0; inpi < inps.length; inpi++) {
                            let imax = invD[invi].q;
                            imax = imax * 1 < 1 ? 0 : imax,
                            _o.a(inps[inpi], "max", imax)
                        }
                        if (invMLbl != "") {
                            let lbls = document.querySelectorAll('[inventory_mark_label="' + invk_r[2] + "_" + invk_r[3] + '"]');
                            for (let inpi = 0; inpi < lbls.length; inpi++)
                                lbls[inpi].innerHTML = invD[invi].q * 1 < 1 ? _o._a(invMLbl, "outofstocklabel") : _o._a(invMLbl, "somelabel").split("{QTY}").join(invD[invi].q)
                        }
                    }
                }
                changeProColorQuantity()
            }
        }
          , changeProColorQuantity = () => {
            var sznlst = _o.cl("efl_size_qty_box");
            for (let szi = 0; szi < sznlst.length; szi++) {
                let mx = _o._a(sznlst[szi], "max");
                mx && mx * 1 < sznlst[szi].value * 1 && (sznlst[szi].value = 0)
            }
            changeProQuantity()
        }
          , selsizestrInitForce = !1
          , clrselid = ""
          , selectedColor = ""
          , SEL_EFL_IMG = ""
          , efl_colorName = ""
          , efl_colorPrice = ""
          , efl_colorHex = ""
          , selectProductColor = function(iid, nnm, ppr, ico) {
            if (inkybayInvInit && distributeInventoryQty(iid),
            clrselid != "") {
                var sdiv = document.getElementById("CLRSEL_" + clrselid);
                sdiv.childNodes[0].setAttribute("class", "inkybay_default_color_swatch")
            }
            clrselid = iid;
            var sdiv = document.getElementById("CLRSEL_" + clrselid);
            sdiv.childNodes[0].setAttribute("class", "inkybay_default_color_swatch idcs_sel"),
            selectedColor = iid + "," + nnm + "," + ppr,
            document.getElementById("INKYBAY_COLOR_SELECTED_TITLE") && (document.getElementById("INKYBAY_COLOR_SELECTED_TITLE").innerHTML = ": " + nnm),
            efl_colorPrice = ppr,
            showInkybayProductCustomPrice();
            for (var pro_images_r = "CL_feature-row__image,CL_zoomImg".split(","), bimgs = [], bi = 0; bi < pro_images_r.length; bi++) {
                var ic = pro_images_r[bi];
                if (ic.substr(0, 3) == "ID_")
                    _o.id(ic.split("ID_").join("")) != null && bimgs.push(_o.id(ic.split("ID_").join("")));
                else
                    for (var imgcls_r = _o.cl(ic.split("CL_").join("")), ici = 0; ici < imgcls_r.length; ici++)
                        bimgs.push(imgcls_r[ici])
            }
            var useImage = _o._a(ico, "useimage")
              , imgurls = _o.id("efl_product_image_s").innerHTML
              , imgurl_r = imgurls.split("|:~SAP~:|")
              , imgurl = imgurl_r[0]
              , thumbhtmlStr = '<a id="EFL_A_HREF" href="*EFL_IMG_THUMB_0*" data-fancybox-group="other-views" class="is-selected a" title="product"></a><ul>';
            if (useImage == "Y") {
                SEL_EFL_IMG = imgurl + "_" + iid + "_orig.png";
                for (var nbi = 0; nbi < bimgs.length; nbi++)
                    _o.a(bimgs[nbi], "crossorigin", "*"),
                    bimgs[nbi].onload = null,
                    bimgs[nbi].src = SEL_EFL_IMG,
                    bimgs[nbi].srcset = SEL_EFL_IMG,
                    bimgs[nbi].setAttribute("data-zoom", SEL_EFL_IMG),
                    bimgs[nbi].setAttribute("data-srcset", SEL_EFL_IMG),
                    bimgs[nbi].setAttribute("data-bgset", SEL_EFL_IMG),
                    bimgs[nbi].setAttribute("data-src", SEL_EFL_IMG),
                    bimgs[nbi].style.visibility = "visible",
                    bimgs[nbi].href = SEL_EFL_IMG,
                    String(bimgs[nbi].tagName).toLowerCase() != "img" && (bimgs[nbi].style.backgroundImage = "url(" + SEL_EFL_IMG + ")",
                    bimgs[nbi].style.backgroundSize = "100%")
            } else {
                for (var i2 = 0; i2 < imgurl_r.length; i2++) {
                    imgurl = imgurl_r[i2] + "_orig.png";
                    var img = new Image;
                    img.crossOrigin = "Anonymous",
                    _o.a(img, "crossorigin", "*"),
                    img.onload = function() {
                        var rgb = iBhexToRgb("#" + iid)
                          , c = document.createElement("canvas");
                        c.width = this.width,
                        c.height = this.height;
                        var x = c.getContext("2d");
                        x.drawImage(this, 0, 0);
                        for (var dt = x.getImageData(0, 0, c.width, c.height), d = dt.data, i3 = 0; i3 < d.length; i3 += 4) {
                            var r = d[i3]
                              , g = d[i3 + 1]
                              , b = d[i3 + 2];
                            d[i3] = r * rgb.r / 255,
                            d[i3 + 1] = g * rgb.g / 255,
                            d[i3 + 2] = b * rgb.b / 255
                        }
                        if (x.putImageData(dt, 0, 0),
                        this.part == 0) {
                            SEL_EFL_IMG = c.toDataURL("image/png");
                            for (var nbi2 = 0; nbi2 < bimgs.length; nbi2++)
                                _o.a(bimgs[nbi2], "crossorigin", "*"),
                                bimgs[nbi2].src = SEL_EFL_IMG,
                                bimgs[nbi2].srcset = SEL_EFL_IMG,
                                bimgs[nbi2].setAttribute("data-zoom", SEL_EFL_IMG),
                                bimgs[nbi2].setAttribute("data-srcset", SEL_EFL_IMG),
                                bimgs[nbi2].setAttribute("data-bgset", SEL_EFL_IMG),
                                bimgs[nbi2].setAttribute("data-src", SEL_EFL_IMG),
                                bimgs[nbi2].href = SEL_EFL_IMG,
                                String(bimgs[nbi2].tagName).toLowerCase() != "img" && (bimgs[nbi2].style.backgroundImage = "url(" + SEL_EFL_IMG + ")",
                                bimgs[nbi2].style.backgroundSize = "100%")
                        }
                        thumbhtmlStr = thumbhtmlStr.split("*EFL_IMG_THUMB_" + this.part + "*").join(c.toDataURL("image/png"))
                    }
                    ,
                    img.src = imgurl,
                    img.col = iid,
                    img.part = i2,
                    thumbhtmlStr += '<li><img src="*EFL_IMG_THUMB_' + i2 + '*" crossorigin="*" /></li>'
                }
                thumbhtmlStr += "</ul>"
            }
            _o.id("EFOLI_BUY_BLANK_BUTTON")
        }
          , iBhexToRgb = function(hex) {
            if (hex == "#-1")
                return {
                    r: 255,
                    g: 255,
                    b: 255
                };
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null
        }
          , changeProQuantityUp = abtn => {
            let qinp = _o.id(_o._a(abtn, "id").split("EFL_PRO_SZUP_QTY_").join("EFL_PRO_SZ_QTY_"))
              , stp = _o._a(qinp, "step");
            stp = stp != null ? stp * 1 : 1,
            qinp.value = qinp.value * 1 + stp,
            changeProQuantity()
        }
          , changeProQuantityDn = abtn => {
            let qinp = _o.id(_o._a(abtn, "id").split("EFL_PRO_SZDN_QTY_").join("EFL_PRO_SZ_QTY_"))
              , stp = _o._a(qinp, "step");
            stp = stp != null ? stp * 1 : 1,
            qinp.value = qinp.value * 1 - stp,
            changeProQuantity()
        }
          , noSizeInitQty = ""
          , cartszqty = "quantity,1,0"
          , addCartBuyBlankQty = ""
          , efl_sizePrice = 0
          , efl_total_product_qty = 0
          , changeProQuantity = function(showLbl) {
            var nnstr = ""
              , qnstr = ""
              , sznlst = _o.cl("efl_size_qty_box")
              , ttlszqtyn = sznlst.length
              , addCartBuyBlankQty_r = [];
            efl_sizePrice = 0;
            var efl_sizeQty = 0;
            if (ttlszqtyn == 0 && _o.id("EFOLI_BUY_OPTION_QUANTITY") && (efl_sizeQty = _o.id("EFOLI_BUY_OPTION_QUANTITY").value),
            selsizestrInitForce) {
                let fszstr = selsizestr.split(",");
                for (var ssi = 0; ssi < ttlszqtyn; ssi++) {
                    var cobj = _o.id("EFL_PRO_SZ_QTY_" + ssi);
                    cobj = cobj ?? sznlst[ssi];
                    let cobjv = _f.is(fszstr[ssi]) ? fszstr[ssi] : "0";
                    nnstr += (ssi == 0 ? "" : ",") + cobjv;
                    var orig_v = _o._a(cobj, "altvalue");
                    cobj.value = cobjv;
                    var sqty = cobj.value;
                    sqty = _f.isn(sqty) ? _f.cl(sqty) : orig_v;
                    var omax_v = _o._a(cobj, "max");
                    sqty = omax_v && omax_v * 1 < sqty ? omax_v : sqty,
                    cobj.value = sqty,
                    _o.a(cobj, "altvalue", sqty),
                    sqty * 1 > 0 && addCartBuyBlankQty_r.push(_o._a(cobj, "inventory_mark") + "_" + sqty);
                    var szprc = Number(cobj.value * Number(cobj.getAttribute("cost")));
                    efl_sizePrice += szprc;
                    var cobjnm = cobj.getAttribute("name");
                    cobjnm = cobjnm.split("&").join("and"),
                    cobjnm = cobjnm.split("#").join(""),
                    cobjnm = cobjnm.split(",").join(" "),
                    cobjnm = cobjnm.split("+").join(""),
                    qnstr += (ssi == 0 ? "" : ";") + cobjnm + "," + cobj.value + "," + szprc,
                    efl_sizeQty += Number(cobj.value)
                }
            } else
                for (var ssi = 0; ssi < ttlszqtyn; ssi++) {
                    var cobj = _o.id("EFL_PRO_SZ_QTY_" + ssi);
                    cobj = cobj ?? sznlst[ssi],
                    nnstr += (ssi == 0 ? "" : ",") + cobj.value;
                    {
                        var orig_v = _o._a(cobj, "altvalue")
                          , sqty = cobj.value;
                        sqty = _f.isn(sqty) ? _f.cl(sqty) : orig_v;
                        var omax_v = _o._a(cobj, "max");
                        sqty = omax_v && omax_v * 1 < sqty ? omax_v : sqty,
                        cobj.value = sqty,
                        _o.a(cobj, "altvalue", sqty),
                        sqty * 1 > 0 && addCartBuyBlankQty_r.push(_o._a(cobj, "inventory_mark") + "_" + sqty);
                        var szprc = Number(cobj.value * Number(cobj.getAttribute("cost")));
                        efl_sizePrice += szprc;
                        var cobjnm = cobj.getAttribute("name");
                        cobjnm = cobjnm.split("&").join("and"),
                        cobjnm = cobjnm.split("#").join(""),
                        cobjnm = cobjnm.split(",").join(" "),
                        cobjnm = cobjnm.split("+").join(""),
                        cobjnm = cobjnm.split(";").join(""),
                        qnstr += (ssi == 0 ? "" : ";") + cobjnm + "," + cobj.value + "," + szprc,
                        efl_sizeQty += Number(cobj.value)
                    }
                }
            selsizestrInitForce = !1,
            selsizestr = nnstr == "" ? noSizeInitQty : nnstr,
            cartszqty = qnstr,
            addCartBuyBlankQty = addCartBuyBlankQty_r.join(";"),
            efl_total_product_qty = efl_sizeQty,
            showLbl = _f.is(showLbl) ? showLbl : !0,
            showLbl && showInkybayProductCustomPrice()
        }
          , calculateDiscountPerQuantity = function(cFor, cPrice) {
            var rtnA = {
                calculatedPrice: cPrice,
                originalPrice: cPrice,
                discountedPrice: 0
            }
              , doDiscount = !1;
            switch (cFor) {
            case "PRODUCT":
                doDiscount = efl_Tier_price_for_product == "Y";
                break;
            case "DESIGN":
                doDiscount = efl_Tier_price_for_design == "Y";
                break;
            case "OPTION":
                doDiscount = efl_Tier_price_for_option == "Y";
                break
            }
            if (doDiscount) {
                var tier_str_r = efl_Tier_price_rule.split("|*~QD~*|");
                efl_Tier_price_rule != "" && tier_str_r.forEach(function(tiers) {
                    var tiers_r = tiers.split("|*~QN~*|");
                    _f.n(efl_total_product_qty) >= _f.n(tiers_r[0]) && (rtnA.discountedPrice = efl_Tier_price_type == "PERCENT" ? cPrice * (_f.n(tiers_r[1]) / 100) : _f.n(tiers_r[1]),
                    rtnA.calculatedPrice = _f.n(cPrice) - _f.n(rtnA.discountedPrice))
                })
            }
            return rtnA
        }
          , mainProductPrice = meta.product.variants[0].price / 100
          , inkybayAllOptionPrice = 0
          , showInkybayProductCustomPrice = function() {
            var oprFields = [];
            if (_o.id("ProductPrice-product-template"))
                oprFields[0] = _o.id("ProductPrice-product-template");
            else
                for (var cloprFields = _o.cl("ProductPrice-product-template"), cci = 0; cci < cloprFields.length; cci++)
                    oprFields.push(cloprFields[cci]);
            if (oprFields.length > 0) {
                changeProQuantity(!1);
                var perSizePrice = _f.n(efl_sizePrice) / (_f.n(efl_total_product_qty) == 0 ? 1 : efl_total_product_qty)
                  , all_inclusive_product_price = _f.n(mainProductPrice) + _f.n(efl_colorPrice) + perSizePrice
                  , display_productPrice = calculateDiscountPerQuantity("PRODUCT", all_inclusive_product_price)
                  , display_optionPrice = calculateDiscountPerQuantity("OPTION", inkybayAllOptionPrice)
                  , total_original_price = display_productPrice.originalPrice + display_optionPrice.originalPrice
                  , total_calculated_price = display_productPrice.calculatedPrice + display_optionPrice.calculatedPrice
                  , display_oprice_flt = Math.round(total_original_price * 100) / 100;
                display_oprice_flt = display_oprice_flt.toFixed(2);
                var display_cprice_flt = Math.round(total_calculated_price * 100) / 100;
                display_cprice_flt = display_cprice_flt.toFixed(2);
                var display_price_html = total_original_price == total_calculated_price ? "<span>$" + display_oprice_flt + "</span>" : '<span style="text-decoration:line-through;opacity:0.8">$' + display_oprice_flt + "</span>&nbsp;<span>$" + display_cprice_flt + "</span>"
                  , all_total_original_price = (display_productPrice.originalPrice + display_optionPrice.originalPrice) * efl_total_product_qty
                  , all_total_calculated_price = (display_productPrice.calculatedPrice + display_optionPrice.calculatedPrice) * efl_total_product_qty
                  , all_display_oprice_flt = Math.round(all_total_original_price * 100) / 100;
                all_display_oprice_flt = all_display_oprice_flt.toFixed(2);
                var all_display_cprice_flt = Math.round(all_total_calculated_price * 100) / 100;
                all_display_cprice_flt = all_display_cprice_flt.toFixed(2);
                var all_display_price_html = all_total_original_price == all_total_calculated_price ? "<span>$" + all_display_oprice_flt + "</span>" : '<span style="text-decoration:line-through;opacity:0.8">$' + all_display_oprice_flt + "</span>&nbsp;<span>$" + all_display_cprice_flt + "</span>";
                oprFields.forEach(function(oprf) {
                    let showAllTotalPrice = _o._a(oprf, "InkybayPriceDisplayType") == "total" || _o._a(oprf, "inkybaypricedisplaytype") == "total";
                    oprf.innerHTML = showAllTotalPrice ? all_display_price_html : display_price_html
                })
            }
        }
          , pro_type = meta.product.type;
        if (pro_type == "PD Custom Product" && typeof meta.product.variants[0] < "u") {
            var nm_str = meta.product.variants[0].name
              , nm_str_r = nm_str.split("customization_id_");
            typeof nm_str_r[1] < "u" ? showProductsDesignerWithTemplate(nm_str_r[1]) : (nm_str_r = nm_str.split("customization_id: "),
            typeof nm_str_r[1] < "u" && showProductsDesignerWithTemplate(nm_str_r[1]))
        }
    }
    if (_o.id("EFOLI_DESIGNER_ROOT")) {
        var loc = String(location);
        loc = loc.split("?")[0];
        var loc_r = loc.split("/pid-")
          , pid = _f.is(loc_r[1]) ? loc_r[1] : 0
          , loc_r = loc.split("/did-")
          , did = _f.is(loc_r[1]) ? loc_r[1] : 0
          , loc_r = loc.split("/cid-")
          , cid = _f.is(loc_r[1]) ? loc_r[1] : 0
          , loc_r = loc.split("/tid-")
          , tid = _f.is(loc_r[1]) ? loc_r[1] : 0
          , aid = ""
          , aloc = String(location);
        aloc = aloc.split("?act="),
        aloc.length > 1 && (aid = aloc[1].split("&")[0]);
        var colalloc = ""
          , cloc = String(location);
        cloc = cloc.split("?procol="),
        cloc.length > 1 && (colalloc = "procol=" + cloc[1].split("&")[0] + "&");
        var sizealloc = ""
          , sloc = String(location);
        sloc = sloc.split("szqty="),
        sloc.length > 1 && (sizealloc = "&szqty=" + sloc[1].split("&")[0]);
        var optionloc = ""
          , oloc = String(location);
        oloc = oloc.split("inkybayoption="),
        oloc.length > 1 && (optionloc = "&inkybayoption=" + oloc[1].split("&")[0]);
        var dgnr_holder = _o.id("EFOLI_DESIGNER_ROOT")
          , mobile_header = ""
          , mobile_header_height = 0
          , main_width = _o.w(dgnr_holder.parentNode);
        dgnr_holder.style.position = "relative",
        dgnr_holder.style.width = "100%",
        dgnr_holder.style.height = "750px";
        var is_show_designer = !0
          , setDesignerPosition = function() {
            main_width = _o.w(dgnr_holder.parentNode);
            var m_styles = window.getComputedStyle(dgnr_holder.parentNode)
              , m_margin = parseFloat(m_styles.marginLeft) + parseFloat(m_styles.marginRight)
              , m_padding = parseFloat(m_styles.paddingLeft) + parseFloat(m_styles.paddingRight)
              , m_border = parseFloat(m_styles.borderLeftWidth) + parseFloat(m_styles.borderRightWidth);
            main_width += m_margin - m_padding + m_border;
            var _ww = _s_WIN.w()
              , _hh = _s_WIN.h()
              , _pwc = "[STUDIO_DISPLAY_WIDTH]"
              , _pw = _pwc != "[STUDIO_DISPLAY_WIDTH]" ? eval(_pwc.split("WINDOW_WIDTH").join(_ww)) : 1e3
              , _phc = "[STUDIO_DISPLAY_HEIGHT]"
              , _ph = _phc != "[STUDIO_DISPLAY_HEIGHT]" ? eval(_phc.split("WINDOW_HEIGHT").join(_hh)) : 700;
            if (dgnr_holder.style.width = "100%",
            dgnr_holder.style.height = _ph + "px",
            dgnr_holder.style.minWidth = "100px",
            _ww > 980) {
                var left_sp = _f.n(main_width) < _pw ? (_pw - _f.n(main_width)) / 2 : 0;
                dgnr_holder.style.left = "-" + left_sp + "px",
                dgnr_holder.style.top = "0px",
                dgnr_holder.style.minWidth = _pw + "px"
            } else {
                dgnr_holder.style.background = "#ffffff";
                var nurlstr = "shop|~=~|meridianplanners-dev.myshopify.com|~G~|efltoken|~=~|1550007284798"
                  , nurlstr_r = nurlstr.split("|~G~|")
                  , mbl_display_str = "yes";
                nurlstr_r.forEach(function(gt) {
                    var gt_r = gt.split("|~=~|");
                    gt_r[0] == "mobile" && (mbl_display_str = _f.is(gt_r[1]) ? gt_r[1] : "yes")
                });
                var mbl_display = mbl_display_str != "no";
                if (mbl_display) {
                    mobile_header_height = 50,
                    typeof MOBILE_HEADER_HEIGHT < "u" && (mobile_header_height = MOBILE_HEADER_HEIGHT),
                    typeof MOBILE_HEADER_HEIGHT < "u" && MOBILE_HEADER_HEIGHT == "NO" && (mobile_header_height = 0);
                    var left_sp = _f.n(main_width) < _ww ? (_ww - _f.n(main_width)) / 2 : 0;
                    dgnr_holder.style.position = "fixed",
                    dgnr_holder.style.left = "0px",
                    dgnr_holder.style.top = "0px",
                    dgnr_holder.style.minWidth = _ww + "px",
                    dgnr_holder.style.height = "100%";
                    for (var title_favicon = "", hlink_r = document.head.getElementsByTagName("link"), mi = 0; mi < hlink_r.length; mi++) {
                        var hlink = hlink_r[mi]
                          , og = hlink.getAttribute("rel");
                        title_favicon = og == "shortcut icon" ? hlink.getAttribute("href") : title_favicon
                    }
                    title_favicon != "" && (title_favicon = title_favicon.split("32x32").join("500x40"),
                    title_favicon = '<a href="https://meridianplanners-dev.myshopify.com"><img src="' + title_favicon + '" ></a>');
                    for (var parent_dholder = dgnr_holder; parent_dholder = parent_dholder.parentNode; )
                        parent_dholder.style && (parent_dholder.style.webkitTransform = "translate3d(0,0,0)",
                        parent_dholder.style.position = "absolute",
                        parent_dholder.style.width = "100%",
                        parent_dholder.style.height = "100%",
                        parent_dholder.style.minWidth = "100%",
                        parent_dholder.style.minHeight = "100%",
                        parent_dholder.style.left = "0px",
                        parent_dholder.style.top = "0px",
                        parent_dholder.style.padding = "0px",
                        parent_dholder.style.margin = "0px",
                        parent_dholder.style.zIndex = 16777271,
                        parent_dholder.style.overflow = "hidden",
                        parent_dholder.style.setProperty("height", "100%", "important"));
                    makeIBWScale(1),
                    setTimeout(function() {
                        makeIBWScale(1)
                    }, 100),
                    setTimeout(function() {
                        makeIBWScale(1)
                    }, 500),
                    setTimeout(function() {
                        makeIBWScale(1)
                    }, 1e3),
                    mobile_header = "",
                    mobile_header_html == "" ? mobile_header_height = 0 : mobile_header = mobile_header_html
                } else
                    is_show_designer = !1
            }
        }
          , makeIBWScale = sc => {
            var Wscale = "scale(" + sc + ") translate3d(0,0,0)";
            document.body.style.webkitTransform = Wscale,
            document.body.style.msTransform = Wscale,
            document.body.style.transform = Wscale
        }
        ;
        setDesignerPosition(),
        window.addEventListener("resize", function() {
            setDesignerPosition()
        }),
        document.body.style.top = "1px",
        setTimeout( () => {
            document.body.style.top = "0px"
        }
        , 1e3),
        is_show_designer ? dgnr_holder.innerHTML = mobile_header + '<div id="firePdesignerInitialized_alt" style="position:absolute;left:0px;top:0px;width:100%;height:100%;text-align:center;"><br/><br/><br/>...</div><iframe onload="firePdesignerInitialized()" src="https://inkybay.com/shopify/out/usr/designer/showDesigner.php?' + colalloc + "pid=" + pid + "&cid=" + cid + "&did=" + did + "&tid=" + tid + "&act=" + aid + "&shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798" + sizealloc + optionloc + '" style="position:absolute;left:0px;top:' + mobile_header_height + "px;height:calc(100% - " + mobile_header_height + 'px);width:100%;border:0px;padding:0px;margin:0px;"></iframe><div style="clear:both;"></div>' : (dgnr_holder.innerHTML = "",
        dgnr_holder.style.display = "none",
        dgnr_holder.id = "_EFOLI_DESIGNER_ROOT")
    }
    var inkybayCartPageLoadfn1 = function() {
        for (var divs = document.getElementsByTagName("div"), spans = document.getElementsByTagName("span"), pars = document.getElementsByTagName("p"), lis = document.getElementsByTagName("li"), aas = document.getElementsByTagName("a"), dtt = document.getElementsByTagName("dt"), ddd = document.getElementsByTagName("dd"), elements_r = [divs, spans, pars, lis, aas, dtt, ddd], searched_qty_boxes = [], findQtyBoxObj = "", findQtyBox = function(celem) {
            if (findQtyBoxObj == "") {
                for (var qtybox = null, ci = 0; ci < celem.children.length; ci++)
                    if (celem.children[ci].name == "updates[]" || celem.children[ci].getAttribute("inkybaydisabled") == "Y") {
                        qtybox = celem.children[ci];
                        var inkdisb = qtybox.getAttribute("inkybaydisabled");
                        if (inkdisb == "N") {
                            return findQtyBoxObj = null,
                            findQtyBoxObj;
                            break
                        }
                        return findQtyBoxObj = qtybox,
                        qtybox;
                        break
                    } else
                        celem.children[ci].children.length > 0 && (qtybox = findQtyBox(celem.children[ci]));
                searched_qty_boxes.push(celem)
            } else
                return findQtyBoxObj;
            return qtybox
        }, ei = 0; ei < elements_r.length; ei++)
            for (var elem = elements_r[ei], hi = 0; hi < elem.length; hi++) {
                var hstr = String(elem[hi].innerHTML).split("<br>").join("|INKYSAP|");
                if (hstr = hstr.split("<p>").join("").split('<p style="display:none;">').join("").split("</p>").join(""),
                (hstr.indexOf("customization_id_") != -1 || hstr.indexOf("buy_blank_id_") != -1 || hstr.indexOf("INACTIVATE_QTY_BOX") != -1) && hstr.indexOf("<") == -1) {
                    var cdiv = elem[hi]
                      , cparent = cdiv
                      , foundQtyInput = !1;
                    for (findQtyBoxObj = ""; !foundQtyInput; ) {
                        cparent = cparent.parentElement;
                        var qbox = findQtyBox(cparent);
                        foundQtyInput = qbox != null,
                        foundQtyInput = foundQtyInput || cparent == document.body
                    }
                    qbox != null ? (qbox.disabled = !0,
                    qbox.style.pointerEvents = "none",
                    qbox.parentNode.style.pointerEvents = "none") : console.log("Quantity Box Not Found or Force Enabled!")
                }
            }
    }
      , checkAttributes = function(el, att) {
        var foundAttr = "";
        return att.forEach(function(attr) {
            foundAttr = el.getAttribute(attr) == "" || el.getAttribute(attr) == null ? foundAttr : el.getAttribute(attr)
        }),
        foundAttr == "" && el.id.split("item_lnno_").length > 1 && (foundAttr = el.id.split("item_lnno_").join("")),
        foundAttr
    }
      , getCartLineNo = function(el) {
        for (var tryStep = 10, afound = !1, rindx = -1; !afound; ) {
            var findex = checkAttributes(el, ["data-cart-item-index", "cart-item-index"]);
            if (findex == "") {
                if (el === document.body)
                    return rindx;
                el = el.parentElement,
                tryStep--,
                tryStep < 1 && (afound = !0)
            } else
                rindx = findex,
                afound = !0
        }
        return rindx
    }
      , inkybayCartPageLoadfn3 = function() {
        for (var divs = document.getElementsByTagName("div"), spans = document.getElementsByTagName("span"), pars = document.getElementsByTagName("p"), smalls = document.getElementsByTagName("small"), linkas = document.getElementsByTagName("a"), lists = document.getElementsByTagName("li"), dtt = document.getElementsByTagName("dt"), ddd = document.getElementsByTagName("dd"), elements_r = [divs, spans, pars, smalls, linkas, lists, dtt, ddd], onshowBuyBlankCart = function(odata, edata) {
            var cdiv2 = edata[0]
              , oid2 = edata[1]
              , astr = cdiv2.innerHTML;
            astr = astr.split('...<div class="inkybay_cart_hide" style="display:none">').join('<div class="inkybay_cart_display">'),
            astr = astr.split("buy_blank_display_place_" + oid2).join(odata),
            astr = astr.split("&lt;br&gt;").join("<br>"),
            astr = astr.split("&lt;p&gt;").join(""),
            cdiv2.innerHTML = astr
        }, ei = 0; ei < elements_r.length; ei++)
            for (var elem = elements_r[ei], hi = 0; hi < elem.length; hi++) {
                var hstr = String(elem[hi].innerHTML).split("<br>").join("");
                if (hstr.indexOf("buy_blank_id_") != -1 && hstr.indexOf("<") == -1) {
                    var cdiv = elem[hi]
                      , oid = hstr.split("buy_blank_id_")[1];
                    oid = oid.split("inkybay_")[0],
                    oid = oid.split(" ")[0],
                    oid = oid.split("<")[0],
                    oid = oid.split("&")[0],
                    oid = oid.replace(/(\r\n|\n|\r|\n\r)/gm, "");
                    var sid_r = hstr.split("size_id_")
                      , sid = _f.is(sid_r[1]) ? sid_r[1] : "0_0_0";
                    sid = sid.split("|INKYSAP|")[0],
                    sid = sid.split("inkybay_")[0],
                    sid = sid.split(" ")[0],
                    sid = sid.split("<")[0],
                    sid = sid.split("&")[0],
                    sid = sid.replace(/(\r\n|\n|\r|\n\r)/gm, "");
                    var cartLineNo = getCartLineNo(cdiv)
                      , optid = 0;
                    if (hstr.indexOf("inkybay_option_id_") != -1) {
                        var optid = hstr.split("inkybay_option_id_")[1];
                        optid = optid.split(" ")[0],
                        optid = optid.split("<")[0],
                        optid = optid.split("&")[0],
                        optid = optid.replace(/(\r\n|\n|\r|\n\r)/gm, "")
                    }
                    cdiv.innerHTML = String(cdiv.innerHTML).split("inkybay_option_id_")[0],
                    cdiv.innerHTML = '...<div class="inkybay_cart_hide" style="display:none">buy_blank_display_place_' + oid + "</div>",
                    _r5 = new _ib_request,
                    _r5.pl("https://inkybay.com/shopify/out/usr/get/showBuyBlankCart_v600.php?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798", "oid=" + oid + "&optid=" + optid + "&cartLineNo=" + cartLineNo + "&sid=" + sid, onshowBuyBlankCart, !0, cdiv, oid)
                }
            }
    }
      , inkybayCartPageLoadfn4 = function() {
        for (var divs = document.getElementsByTagName("div"), spans = document.getElementsByTagName("span"), pars = document.getElementsByTagName("p"), smalls = document.getElementsByTagName("small"), linkas = document.getElementsByTagName("a"), lists = document.getElementsByTagName("li"), dtt = document.getElementsByTagName("dt"), ddd = document.getElementsByTagName("dd"), elements_r = [divs, spans, pars, smalls, linkas, lists, dtt, ddd], onshowCustomDesignCart = function(odata, edata) {
            var cdiv2 = edata[0]
              , oid2 = edata[1]
              , astr = cdiv2.innerHTML;
            if (astr = astr.split('...<div class="inkybay_cart_hide" style="display:none">').join('<div class="inkybay_cart_display">'),
            astr = astr.split("customization_display_place_" + oid2).join(odata),
            astr = astr.split("&lt;br&gt;").join("<br>"),
            astr = astr.split("&lt;p&gt;").join(""),
            document.getElementById("IB_CART_REPLACE_STR")) {
                let ibrpr = document.getElementById("IB_CART_REPLACE_STR").innerHTML.split("||");
                for (let ibi = 0; ibi < ibrpr.length; ibi++) {
                    let ibrprs = ibrpr[ibi].split("~");
                    typeof ibrprs[1] < "u" && (astr = astr.split(ibrprs[0]).join(ibrprs[1]))
                }
            }
            cdiv2.innerHTML = astr,
            resetcstmcount()
        }, ei = 0; ei < elements_r.length; ei++)
            for (var elem = elements_r[ei], hi = 0; hi < elem.length; hi++) {
                var hstr = String(elem[hi].innerHTML).split("<br>").join("");
                if (hstr.indexOf("customization_id_") != -1 && hstr.indexOf("<") == -1) {
                    var cdiv = elem[hi]
                      , oid = hstr.split("customization_id_")[1];
                    oid = oid.split("|INKYSAP|")[0],
                    oid = oid.split("inkybay_")[0],
                    oid = oid.split(" ")[0],
                    oid = oid.split("<")[0],
                    oid = oid.split("&")[0],
                    oid = oid.replace(/(\r\n|\n|\r|\n\r)/gm, "");
                    var sid_r = hstr.split("size_id_")
                      , sid = _f.is(sid_r[1]) ? sid_r[1] : "0_0_0";
                    sid = sid.split("|INKYSAP|")[0],
                    sid = sid.split("inkybay_")[0],
                    sid = sid.split(" ")[0],
                    sid = sid.split("<")[0],
                    sid = sid.split("&")[0],
                    sid = sid.replace(/(\r\n|\n|\r|\n\r)/gm, "");
                    var cartLineNo = getCartLineNo(elem[hi])
                      , optid = 0;
                    if (hstr.indexOf("inkybay_option_id_") != -1) {
                        var optid = hstr.split("inkybay_option_id_")[1];
                        optid = optid.split(" ")[0],
                        optid = optid.split("<")[0],
                        optid = optid.split("&")[0],
                        optid = optid.replace(/(\r\n|\n|\r|\n\r)/gm, "")
                    }
                    cdiv.innerHTML = String(cdiv.innerHTML).split("inkybay_option_id_")[0],
                    cdiv.innerHTML = '...<div class="inkybay_cart_hide" style="display:none">customization_display_place_' + oid + "</div>",
                    _r5 = new _ib_request,
                    _r5.pl("https://inkybay.com/shopify/out/usr/get/showCustomDesignCart_v600.php?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798&lslag=" + iBwLocalSlag, "oid=" + oid + "&cartLineNo=" + cartLineNo + "&optid=" + optid + "&sid=" + sid, onshowCustomDesignCart, !0, cdiv, oid)
                }
            }
    }
      , inkybayCartRefreash = function() {
        meta.page.pageType == "product" && ibspi_available || (typeof inkybayCartPageLoadfn1 < "u" && _f.isf(inkybayCartPageLoadfn1) && inkybayCartPageLoadfn1(),
        typeof inkybayCartPageLoadfn2 < "u" && _f.isf(inkybayCartPageLoadfn2) && inkybayCartPageLoadfn2(),
        typeof inkybayCartPageLoadfn3 < "u" && _f.isf(inkybayCartPageLoadfn3) && inkybayCartPageLoadfn3(),
        typeof inkybayCartPageLoadfn4 < "u" && _f.isf(inkybayCartPageLoadfn4) && inkybayCartPageLoadfn4())
    }
      , cstmidcount = 0
      , inkyallcartinp = []
      , inkybayCartAutoRefreash = () => {
        let cnt = (document.body.innerHTML.match(/name(\s+)?=(\s+)?"update/g) || []).length;
        cstmidcount != cnt && (inkybayCartRefreash(),
        autoRemoveSameDesignCartItem(),
        resetcstmcount());
        let allinp = document.querySelectorAll("input");
        for (let inpi = 0; inpi < allinp.length; inpi++) {
            let inp = allinp[inpi];
            _o._a(inp, "name") && _o._a(inp, "name").search("update") !== -1 && inkyallcartinp.indexOf(inp) == -1 && (inp.addEventListener("change", e => {
                inkybayCartRefreash(),
                autoRemoveSameDesignCartItem(),
                resetcstmcount(),
                setTimeout(inkybayCartRefreash, 2e3)
            }
            ),
            inkyallcartinp.push(inp))
        }
    }
      , resetcstmcount = () => {
        cstmidcount = (document.body.innerHTML.match(/name(\s+)?=(\s+)?"update/g) || []).length
    }
      , refreash_customize_it = function() {
        for (var cmi = 0; cmi < customizable_pro_id_arr.length; cmi++) {
            var cpro_i_d = customizable_pro_id_arr[cmi]
              , crt_btn = _o.id("inkybay_collection_cart_btn_" + cpro_i_d);
            crt_btn && crt_btn.style.setProperty("display", "none", "important");
            var ctm_btn = _o.id("inkybay_collection_customizeit_btn_" + cpro_i_d);
            ctm_btn && (ctm_btn.style.display = "inline-block",
            ctm_btn.href = iBwOrigin + "/pages/designlab/pid-" + cpro_i_d,
            ctm_btn.customizelink = iBwOrigin + "/pages/designlab/pid-" + cpro_i_d,
            ctm_btn.onclick = e => {
                console.log(e.currentTarget.customizelink),
                event.preventDefault(),
                location = e.currentTarget.customizelink
            }
            );
            for (var crbtns_r = _o.cl("inkybay_collection_cart_btn_" + cpro_i_d), ici = 0; ici < crbtns_r.length; ici++)
                crbtns_r[ici].style.setProperty("display", "none", "important");
            for (var cubtns_r = _o.cl("inkybay_collection_customizeit_btn_" + cpro_i_d), ici = 0; ici < cubtns_r.length; ici++)
                cubtns_r[ici].style.display = "inline-block"
        }
        for (var allCartList = _o.cl("inkybay_collection_cart_btn_hidden"), ili = 0; ili < allCartList.length; ili++) {
            let cproid = _o._a(allCartList[ili], "id").split("inkybay_collection_cart_btn_").join("");
            customizable_pro_id_arr.indexOf(cproid) == -1 && (allCartList[ili].style.display = "inline-block")
        }
    };
    if (refreash_customize_it(),
    _o.id("INKYBAY_DESIGN_IDEA_LOADER")) {
        var dih = _o.id("INKYBAY_DESIGN_IDEA_LOADER");
        dih.innerHTML = ".";
        var ibhead = document.getElementsByTagName("head")[0]
          , ibhscript = document.createElement("script");
        ibhscript.type = "text/javascript",
        ibhscript.onload = function() {
            designIdeaInit()
        }
        ,
        ibhscript.src = "https://inkybay.com/shopify/out/usr/js/designidea.js?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798",
        ibhead.appendChild(ibhscript)
    }
    if (_o.id("INKYBAY_DESIGN_CLIPART_LOADER")) {
        var dih = _o.id("INKYBAY_DESIGN_CLIPART_LOADER");
        dih.innerHTML = ".";
        var ibhead = document.getElementsByTagName("head")[0]
          , ibhscript = document.createElement("script");
        ibhscript.type = "text/javascript",
        ibhscript.onload = function() {
            designClipInit()
        }
        ,
        ibhscript.src = "https://inkybay.com/shopify/out/usr/js/designclipart.js?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798",
        ibhead.appendChild(ibhscript)
    }
    var afterInkybayCartRemoval = function(d, p) {
        console.log(d)
    }
      , afterInkybayAddToCart = function(d, p) {
        inkybayFinalPostTimes++;
        var jd = JSON.parse(d);
        !_f.is(jd.items) || jd.items.length * 1 < 1 ? inkybayFinalPostTimes < 4 ? setTimeout( () => {
            _r.pl(iBwOrigin + "/cart/add.js", inkybayFinalPostCurrentData, afterInkybayAddToCart)
        }
        , 1e3) : console.log("Tried " + inkybayFinalPostTimes + " times on add to cart!") : location = iBwOrigin + "/cart"
    }
      , inkybayFinalPostCurrentData = []
      , inkybayFinalPostTimes = 0
      , showInkybayProductDetails = function(e) {
        let descDiv = document.getElementById("EFL_PRODUCT_DESCRIPTION_VIEW")
          , dta = String(e.data);
        if (dta.substr(0, 28) == "INKYBAY_PRODUCT_DESCRIPTION:" && descDiv && (dta = dta.substr(28),
        dta = dta.split("``").join('"'),
        descDiv.innerHTML = dta),
        dta.substr(0, 21) == "INKYBAY_CART_REMOVAL:") {
            dta = dta.substr(21);
            let postData = "line=" + dta + "&quantity=0";
            _r.pl(iBwOrigin + "/cart/change.js", postData, afterInkybayCartRemoval)
        }
        if (dta.substr(0, 20) == "INKYBAY_ADD_TO_CART:") {
            let dtr = dta.split("|*~CARTDATA~*|");
            var pvr = dtr[1].split("|")
              , final_post_data = "";
            for (let pvi = 0; pvi < pvr.length; pvi++) {
                let pvid = pvr[pvi]
                  , pvqty_r = dtr[2].split("|")
                  , pvqty = _f.is(pvqty_r[pvi]) ? pvqty_r[pvi] : 0;
                pvsize_r = dtr[4].split("|~SZ-SAP~|"),
                pvsize = _f.is(pvsize_r[pvi]) ? pvsize_r[pvi] : "";
                let propertiesd = "";
                propertiesd += "&items[" + pvi + "][properties][_inkybay_customization_id]=" + dtr[3],
                propertiesd += "&items[" + pvi + "][properties][_inkybay_size_quantity]=" + pvsize,
                propertiesd += "&items[" + pvi + "][properties][_inkybay_product_color]=" + dtr[5],
                propertiesd += "&items[" + pvi + "][properties][_inkybay_same_design_items]=" + pvr.join(",");
                let optiondata = "";
                dtr[6] && dtr[6] != "" && dtr[7] && dtr[7] != "" && (optiondata += "&items[" + pvi + "][properties][_inkybay_option_id]=" + dtr[6],
                optiondata += "&items[" + pvi + "][properties][_inkybay_option_data]=" + dtr[7]);
                let postData = "items[" + pvi + "][id]=" + pvid + "&items[" + pvi + "][quantity]=" + pvqty + propertiesd + optiondata;
                final_post_data += (final_post_data == "" ? "" : "&") + postData
            }
            inkybayFinalPostCurrentData = final_post_data,
            _r.pl(iBwOrigin + "/cart/add.js", final_post_data, afterInkybayAddToCart)
        }
    };
    window.addEventListener("message", showInkybayProductDetails, !1);
    var autoRemoveSameDesignCartItem = () => {
        inkybayLockCartPage(),
        _r.sl(iBwOrigin + "/cart.json", "", autoRemoveSameDesignCartItemCart)
    }
      , autoRemoveSameDesignCartItemCart = (d, p) => {
        var cdata = JSON.parse(d)
          , sd_ids = []
          , cs_ids = []
          , cs_num = [];
        for (let cdi = 0; cdi < cdata.items.length; cdi++) {
            var prop = cdata.items[cdi].properties;
            if (prop && (_f.is(prop._inkybay_customization_id) || _f.is(prop._inkybay_buyblank_id))) {
                let sdid = _f.is(prop._inkybay_customization_id) ? prop._inkybay_customization_id : prop._inkybay_buyblank_id;
                sd_ids[sdid] = _f.is(sd_ids[sdid]) ? sd_ids[sdid] : [],
                sd_ids[sdid].push(cdata.items[cdi]),
                cs_ids.indexOf(sdid) == -1 && (cs_ids.push(sdid),
                cs_num[sdid] = prop._inkybay_same_design_items.split(",").length)
            }
        }
        var crtRI = [];
        for (let ici = 0; ici < cs_ids.length; ici++) {
            let sdid = cs_ids[ici];
            if (sd_ids[sdid].length != cs_num[sdid] * 1)
                for (let nsii = 0; nsii < sd_ids[sdid].length; nsii++)
                    crtRI.push(sd_ids[sdid][nsii].id)
        }
        crtRI.length > 0 ? inkybayCartRemoveItems(crtRI) : inkybayUnlockCartPage()
    }
      , isInkybayLockCartPage = !1
      , inkybayLockCartPage = () => {
        if (!isInkybayLockCartPage && window.location.pathname.split("/").join("") == "cart") {
            let lscreen = document.createElement("div");
            lscreen.id = "INKYBAY_CART_LOCK_COVER",
            lscreen.style = "display:block;position:fixed;width:100%;height:100%;background:#cccccc22;z-index:9999999999;",
            document.body.appendChild(lscreen),
            isInkybayLockCartPage = !0
        }
    }
      , inkybayUnlockCartPage = () => {
        if (isInkybayLockCartPage) {
            var lscreen = document.getElementById("INKYBAY_CART_LOCK_COVER");
            lscreen && document.body.removeChild(lscreen),
            isInkybayLockCartPage = !1
        }
    }
    ;
    typeof AUTO_REMOVE_SAME_DESIGN_CART_ITEM < "u" && AUTO_REMOVE_SAME_DESIGN_CART_ITEM == "NO" || (document.readyState === "interactive" || document.readyState === "complete" ? (resetcstmcount(),
    setInterval(inkybayCartAutoRefreash, 1e3),
    setTimeout(autoRemoveSameDesignCartItem, 1100)) : window.addEventListener("load", () => {
        resetcstmcount(),
        setInterval(inkybayCartAutoRefreash, 1e3),
        setTimeout(autoRemoveSameDesignCartItem, 1100)
    }
    , !1));
    var inkybayCartRemoveItems = crtRI => {
        var remStr = "";
        for (i = 0; i < crtRI.length; i++)
            remStr += (remStr == "" ? "" : "&") + "updates[" + crtRI[i] + "]=0";
        _r.pl(iBwOrigin + "/cart/update.js", remStr, afterInkybayCartRemoveItems)
    }
      , afterInkybayCartRemoveItems = () => {
        location = iBwOrigin + "/cart"
    }
    ;
    inkybayCartPageLoadfn1(),
    inkybayCartPageLoadfn3(),
    inkybayCartPageLoadfn4();
    var pageBackReload = !0;
    setInterval( () => {
        performance.navigation.type == 2 && pageBackReload && (location.reload(!1),
        pageBackReload = !1)
    }
    , 500);
    var OPTIONSET_RULE_STR = "handle|:~RULE_VALUE~:|invoice-pay";
    if (meta.page.pageType == "product" && ibspi_available) {
        let ib_post_encode2 = function(str) {
            for (var clear_status = !1; clear_status == !1; )
                pstr = str,
                str = str.replace("&", "*|olo.amp|*"),
                str = str.replace("#", "*|olo.hash|*"),
                str = str.replace("+", "*|olo.plus|*"),
                str = str.replace('"', "*|olo.dquot|*"),
                str = str.replace("'", "*|olo.squot|*"),
                str = str.replace(">", "*|olo.gt|*"),
                str = str.replace("<", "*|olo.lt|*"),
                str = str.replace("=", "*|olo.eq|*"),
                str = str.replace(",", "*|olo.comma|*"),
                pstr == str && (clear_status = !0);
            return str
        };
        var ib_post_encode = ib_post_encode2
          , ib_po_before_div = "";
        if (is_customizable)
            ib_po_before_div = _o.id("SHOW_SIZE_COLOR_DIV") ? _o.id("SHOW_SIZE_COLOR_DIV") : customize_btn;
        else {
            var cart_btn_form = "NOTFOUND";
            if (document.forms.length == 0)
                cart_btn_form = "NOTFOUND";
            else
                for (var fi = 0; fi < document.forms.length; fi++) {
                    var frm = document.forms[fi]
                      , frmhidden = frm.offsetParent === null;
                    frm.hasAttribute("action") && frm.getAttribute("action").indexOf("/cart/add") >= 0 && cart_btn_form == "NOTFOUND" && !frmhidden && (cart_btn_form = frm)
                }
            cart_btn_form == "NOTFOUND" && (_o.id("EFOLI_DESIGNER_CUSTOMIZE_IT_BUTTON_PLACE") || console.log("No space found for options")),
            ib_po_before_div = cart_btn_form
        }
        var alreadyiboplace = _o.id("INKYBAY_PRODUCT_OPTION_DIV")
          , ib_po_place = alreadyiboplace ? _o.id("INKYBAY_PRODUCT_OPTION_DIV") : _o.ce("div", "INKYBAY_PRODUCT_OPTION_DIV");
        if (ib_po_place.style.width = "100%",
        ib_po_place.style.display = "none",
        cart_btn_form != "NOTFOUND")
            alreadyiboplace || ib_po_before_div.parentNode.insertBefore(ib_po_place, ib_po_before_div);
        else if (_o.id("EFOLI_DESIGNER_CUSTOMIZE_IT_BUTTON_PLACE")) {
            var ibopt_holder = _o.id("EFOLI_DESIGNER_CUSTOMIZE_IT_BUTTON_PLACE");
            ibopt_holder.parentNode.insertBefore(ib_po_place, ibopt_holder),
            ibHideDefaultForm()
        }
        var mainProductPrice = 0, hasInkyBayOptions = !1, onloadIBProductOption = function(data) {
            data_r = data.split("|:~PAGEDATA~:|");
            var v = data_r[0];
            ib_po_place.innerHTML = v;
            var has_entire_option = !1;
            if (v != "") {
                var vopt = data_r[2].split("|:~OPTSETID~:|");
                has_entire_option = _f.is(vopt[1]) && vopt[1] != ""
            }
            v != "" && has_entire_option ? (document.head.insertAdjacentHTML("beforeend", "<style>.inkybay_option_product_hide_elements{display:none !important;}</style>"),
            ib_po_place.style.display = "block",
            _f.is(data_r[4]) && initializeOptionProductImages(data_r[4]),
            initializeChildOptions(data_r[1]),
            mainProductPrice = _f.n(data_r[3]),
            initializePriceOptions(data_r[2]),
            initializeUploadFiles(),
            initializeButtons()) : (inkybay_option_price_initialized = !0,
            ib_po_place.style.display = "none",
            mainProductPrice = _f.n(data_r[3]),
            _o.id("INKYBAY_OPTION_HIDE_FORM_SCRIPT") && (_o.id("INKYBAY_OPTION_HIDE_FORM_SCRIPT").innerHTML = ""))
        }, CHILD_OPTION_ARR = [], initializeChildOptions = function(schld_str) {
            if (schld_str != "")
                for (var schld_str_r = schld_str.split("|:~OPTSET~:|"), sci = 0; sci < schld_str_r.length; sci++) {
                    var nchld_str_r = schld_str_r[sci].split("|:~OPTSETID~:|")
                      , chld_id = nchld_str_r[0]
                      , chld_str = nchld_str_r[1];
                    if (CHILD_OPTION_ARR["SET_" + chld_id] = [],
                    chld_str != "")
                        for (var chld_str_r = chld_str.split("|~OPT~|"), ci = 0; ci < chld_str_r.length; ci++) {
                            var cc_r = chld_str_r[ci].split("|~OPTID~|");
                            CHILD_OPTION_ARR["SET_" + chld_id]["OPT_" + cc_r[0]] = cc_r[1].split("|~|");
                            var obj = _o.id("inkybay_opt_" + cc_r[0])
                              , indx = _o._a(obj, "inkyindx")
                              , val = _o._a(obj, "inkyval")
                              , inpobj = _o.id("inkybay_option_" + cc_r[0] + "_" + indx);
                            inkybayChangeSingleChoice(chld_id, cc_r[0], val, indx, inpobj)
                        }
                }
            let szcand = _o.cl("designersizecandidate");
            if (szcand.length > 0) {
                for (let sci2 in szcand)
                    if (typeof szcand[sci2] == "object" && szcand[sci2].offsetParent !== null && _o._a(szcand[sci2], "dgnrsize") == "yes") {
                        let setid = _o._a(szcand[sci2], "setid")
                          , optid = _o._a(szcand[sci2], "id").split("inkybay_opt_").join("")
                          , unt = _o.id("inkybay_option_custom_size_unit_" + setid + "_" + optid).value;
                        val_r = _o._a(szcand[sci2], "inkyval").split("_")[0].split("|:~")[0].split("x"),
                        INKYBAY_OPTION_SIZE[0] = val_r[0],
                        INKYBAY_OPTION_SIZE[1] = val_r[1],
                        INKYBAY_OPTION_SIZE[2] = unt
                    }
            }
            let szinp = _o.cl("inkybay_option_number_customsize_width");
            if (szinp.length > 0) {
                for (let szi in szinp)
                    if (typeof szinp[szi] == "object" && szinp[szi].offsetParent !== null) {
                        let id_r = _o._a(szinp[szi], "id").split("inkybay_option_custom_size_width_").join("").split("_")
                          , setid = id_r[0]
                          , optid = id_r[1];
                        inkyBayOptionChangeCustomSizeDefaultUnit(setid, optid, _o.id("inkybay_option_custom_size_unit_" + setid + "_" + optid).value)
                    }
            }
        }, INKYBAY_OPTION_SIZE = [0, 0, "in"], inkyBayOptionChangeCustomSizeDefaultUnit = (setid, optid, unt) => {
            var uinp = _o.id("inkybay_option_custom_size_unit_" + setid + "_" + optid)
              , fixedFactor = _o._a(uinp, "fixedfactor")
              , wFixedValue_r = _o._a(uinp, "wfixed").split("_")
              , hFixedValue_r = _o._a(uinp, "hfixed").split("_")
              , frm2 = _o.id("INCFACTORS_" + setid + "_" + optid).innerHTML
              , frm_r = frm2.split("_")
              , inc_r = {
                in: frm_r[0],
                cm: frm_r[1],
                ft: frm_r[2]
            }
              , cinc = inc_r[unt]
              , winp = _o.id("inkybay_option_custom_size_width_" + setid + "_" + optid)
              , hinp = _o.id("inkybay_option_custom_size_height_" + setid + "_" + optid)
              , fixedStep = _o._a(winp, "fixedstep") == "yes";
            _o.a(winp, "step", cinc),
            _o.a(hinp, "step", cinc),
            _o.a(winp, "min", _o._a(winp, "min" + unt)),
            _o.a(winp, "max", _o._a(winp, "max" + unt)),
            _o.a(hinp, "min", _o._a(hinp, "min" + unt)),
            _o.a(hinp, "max", _o._a(hinp, "max" + unt));
            let wmin = fixedStep ? fixMultiplier(_o._a(winp, "min") * 1, cinc * 1, _o._a(winp, "min") * 1, _o._a(winp, "max") * 1) : _o._a(winp, "min")
              , wmax = fixedStep ? fixMultiplier(_o._a(winp, "max") * 1, cinc * 1, _o._a(winp, "min") * 1, _o._a(winp, "max") * 1) : _o._a(winp, "max")
              , hmin = fixedStep ? fixMultiplier(_o._a(hinp, "min") * 1, cinc * 1, _o._a(hinp, "min") * 1, _o._a(hinp, "max") * 1) : _o._a(hinp, "min")
              , hmax = fixedStep ? fixMultiplier(_o._a(hinp, "max") * 1, cinc * 1, _o._a(hinp, "min") * 1, _o._a(hinp, "max") * 1) : _o._a(hinp, "max");
            _o.id("inkybay_option_customsize_min_label_width_" + setid + "_" + optid).innerHTML = wmin,
            _o.id("inkybay_option_customsize_max_label_width_" + setid + "_" + optid).innerHTML = wmax,
            _o.id("inkybay_option_customsize_min_label_height_" + setid + "_" + optid).innerHTML = hmin,
            _o.id("inkybay_option_customsize_max_label_height_" + setid + "_" + optid).innerHTML = hmax;
            var fxdInpIndx = {
                in: 0,
                cm: 1,
                ft: 2
            };
            switch (fixedFactor) {
            case "fixed_width":
                winp.value = wFixedValue_r[fxdInpIndx[unt]];
                break;
            case "fixed_height":
                hinp.value = hFixedValue_r[fxdInpIndx[unt]];
                break
            }
            _o.a(uinp, "currvalue", unt),
            updateCustomSizeWidth(setid, optid, winp),
            updateCustomSizeHeight(setid, optid, hinp)
        }
        , fixMultiplier = (val, step, minq, maxq) => {
            let rm = val % step
              , cval = step - rm < rm ? val + (step - rm) : val - rm;
            return cval = cval < minq ? val + (step - rm) : cval,
            cval = cval > maxq ? val - rm : cval,
            cval
        }
        , updateCustomSizeWidth = (setid, optid, inp) => {
            var val = inp.value * 1;
            let minq = _o._a(inp, "min") * 1
              , maxq = _o._a(inp, "max") * 1
              , dgnrSize = _o._a(inp, "dgnrsize") == "yes"
              , fixedStep = _o._a(inp, "fixedstep") == "yes"
              , step = _o._a(inp, "step") * 1;
            val = val > maxq ? maxq : val,
            val = val < minq ? minq : val,
            val % step != 0 && fixedStep && (val = fixMultiplier(val, step, minq, maxq)),
            val = Math.round(val * 1e3) / 1e3,
            inp.value = val;
            let unt = _o.id("inkybay_option_custom_size_unit_" + setid + "_" + optid).value;
            dgnrSize && (INKYBAY_OPTION_SIZE[0] = val,
            INKYBAY_OPTION_SIZE[2] = unt);
            var obj = _o.id("inkybay_opt_" + optid);
            let pval_r = _o._a(obj, "inkyval").split("_")[0].split("x");
            pval_r[0] = val;
            let fval = pval_r.join("x") + "_" + unt;
            var obj = _o.id("inkybay_opt_" + optid);
            obj.inkyval = fval,
            _o.a(obj, "inkyval", fval),
            recalculateOption()
        }
        , updateCustomSizeHeight = (setid, optid, inp) => {
            var val = inp.value * 1;
            let minq = _o._a(inp, "min") * 1
              , maxq = _o._a(inp, "max") * 1
              , dgnrSize = _o._a(inp, "dgnrsize") == "yes"
              , fixedStep = _o._a(inp, "fixedstep") == "yes"
              , step = _o._a(inp, "step") * 1;
            val = val > maxq ? maxq : val,
            val = val < minq ? minq : val,
            val % step != 0 && fixedStep && (val = fixMultiplier(val, step, minq, maxq)),
            val = Math.round(val * 1e3) / 1e3,
            inp.value = val;
            let unt = _o.id("inkybay_option_custom_size_unit_" + setid + "_" + optid).value;
            dgnrSize && (INKYBAY_OPTION_SIZE[1] = val,
            INKYBAY_OPTION_SIZE[2] = unt);
            var obj = _o.id("inkybay_opt_" + optid);
            let pval_r = _o._a(obj, "inkyval").split("_")[0].split("x");
            pval_r[1] = val;
            let fval = pval_r.join("x") + "_" + unt;
            obj.inkyval = fval,
            _o.a(obj, "inkyval", fval),
            recalculateOption()
        }
        , indecreaseCustomSize = (setid, optid, fct) => {
            var tinp, incf = 1, incv = 1;
            switch (fct) {
            case 0:
                tinp = _o.id("inkybay_option_custom_size_width_" + setid + "_" + optid),
                incf = -1;
                break;
            case 1:
                tinp = _o.id("inkybay_option_custom_size_width_" + setid + "_" + optid);
                break;
            case 2:
                tinp = _o.id("inkybay_option_custom_size_height_" + setid + "_" + optid),
                incf = -1;
                break;
            case 3:
                tinp = _o.id("inkybay_option_custom_size_height_" + setid + "_" + optid);
                break
            }
            incv = _o._a(tinp, "step") * 1;
            let tinpv = Math.round((tinp.value * 1 + incv * incf) * 1e3) / 1e3;
            tinp.value = tinpv,
            fct == 0 || fct == 1 ? updateCustomSizeWidth(setid, optid, tinp) : updateCustomSizeHeight(setid, optid, tinp)
        }
        , inkybayChangeSingleChoice = function(setid, optid, val, index, inpobj) {
            if (index = val == "CUSTOM_SIZE_VALUE" ? "CUSTOMSIZE" : index,
            typeof CHILD_OPTION_ARR["SET_" + setid]["OPT_" + optid] < "u")
                for (var all_opt_r = CHILD_OPTION_ARR["SET_" + setid]["OPT_" + optid], ai = 0; ai < all_opt_r.length; ai++) {
                    var vis = index == all_opt_r[ai]
                      , chld_opts = document.getElementsByClassName("inkybay_child_opt_" + optid + "_" + all_opt_r[ai]);
                    if (chld_opts.length > 0)
                        for (var chi = 0; chi < chld_opts.length; chi++) {
                            var chld_opt = chld_opts[chi];
                            chld_opt.style.display = vis ? "block" : "none"
                        }
                }
            var obj = _o.id("inkybay_opt_" + optid);
            obj.inkyval = val,
            _o.a(obj, "inkyval", val),
            obj.inkyindx = index,
            _o.a(obj, "inkyindx", index);
            var chldObj = _o.id("inkybay_option_" + optid + "_" + index);
            if (set_product_image_part(_o._a(chldObj, "pro_image_part"), _o._a(obj, "option_relation"), optid, setid),
            _o.id("inkybay_option_custom_size_" + setid + "_" + optid) && (_o.id("inkybay_option_custom_size_" + setid + "_" + optid).style.display = "none"),
            val == "CUSTOM_SIZE_VALUE")
                _o.id("inkybay_option_custom_size_" + setid + "_" + optid).style.display = "block",
                inkyBayOptionChangeCustomSizeDefaultUnit(setid, optid, _o.id("inkybay_option_custom_size_unit_" + setid + "_" + optid).value);
            else if (_o._a(obj, "dgnrsize") == "yes") {
                let unt = _o._a(_o.id("inkybay_option_custom_size_unit_" + setid + "_" + optid), "calcunit")
                  , val_r2 = val.split("_")[0].split("|:~")[0].split("x");
                INKYBAY_OPTION_SIZE[0] = val_r2[0],
                INKYBAY_OPTION_SIZE[1] = val_r2[1],
                INKYBAY_OPTION_SIZE[2] = unt
            }
            recalculateOption()
        }, inkybayChangeMultipleChoice = function(setid, optid, val, index, inpobj) {
            if (typeof CHILD_OPTION_ARR["SET_" + setid]["OPT_" + optid] < "u")
                for (var all_opt_r = CHILD_OPTION_ARR["SET_" + setid]["OPT_" + optid], ai = 0; ai < all_opt_r.length; ai++) {
                    var vis = index == all_opt_r[ai]
                      , chld_opts = document.getElementsByClassName("inkybay_child_opt_" + optid + "_" + all_opt_r[ai]);
                    if (chld_opts.length > 0)
                        for (var chi = 0; chi < chld_opts.length; chi++) {
                            var chld_opt = chld_opts[chi];
                            chld_opt.style.display = vis ? "block" : "none"
                        }
                }
            var obj = _o.id("inkybay_opt_" + optid)
              , preval = _o._a(obj, "inkyval")
              , preindx = _o._a(obj, "inkyindx");
            if (inpobj.checked)
                val = preval == "" ? val : preval + "|:~SAP~:|" + val,
                index = preindx == "" ? index : preindx + "|:~SAP~:|" + index;
            else {
                for (var val_r2 = preval.split("|:~SAP~:|"), nval_r = [], vi = 0; vi < val_r2.length; vi++)
                    val_r2[vi] != val && nval_r.push(val_r2[vi]);
                for (var inx_r = preindx.split("|:~SAP~:|"), ninx_r = [], vi = 0; vi < inx_r.length; vi++)
                    inx_r[vi] != index && ninx_r.push(inx_r[vi]);
                val = nval_r.join("|:~SAP~:|"),
                index = ninx_r.join("|:~SAP~:|")
            }
            obj.inkyval = val,
            _o.a(obj, "inkyval", val),
            obj.inkyindx = index,
            _o.a(obj, "inkyindx", index),
            recalculateOption()
        }, product_render_image = "", product_render_image_zoom = "", product_render_parts = [], initializeOptionProductImages = function(data) {
            if (data = data == "" ? "N" : data,
            data != "N") {
                for (var pro_images_r = "CL_feature-row__image,CL_zoomImg".split(","), oimgs = [], bi = 0; bi < pro_images_r.length; bi++) {
                    var ic = pro_images_r[bi];
                    if (ic.substr(0, 3) == "ID_")
                        oimgs.push(_o.id(ic.split("ID_").join("")));
                    else
                        for (var imgcls_r = _o.cl(ic.split("CL_").join("")), ici = 0; ici < imgcls_r.length; ici++)
                            oimgs.push(imgcls_r[ici])
                }
                if (_f.is(oimgs[0])) {
                    product_render_image = oimgs[0],
                    _f.is(oimgs[1]) && (product_render_image_zoom = oimgs[1]);
                    for (var data_r2 = data.split("|~OPTION_IMAGES~|"), di = 0; di < data_r2.length; di++) {
                        var simg_r = data_r2[di].split("|~OPTION_IMG_ATTR~|");
                        set_product_image_part(simg_r[0], simg_r[1], simg_r[2], simg_r[3])
                    }
                }
            }
        }, lopp_refreashTimer = new Date().getTime(), lopp_refreashTimeOut, loadOptionProductParts = function() {
            clearTimeout(lopp_refreashTimeOut);
            var rTimer = new Date().getTime();
            if (rTimer - lopp_refreashTimer < 1e3)
                return lopp_refreashTimeOut = setTimeout(loadOptionProductParts, 500),
                !1;
            lopp_refreashTimer = new Date().getTime();
            for (var imgs_r = [], cnv_rect = [0, 0, 0, 0], pi = 0; pi < product_images_fr_count; pi++) {
                var noptid = product_images_fr_r[pi]
                  , img_part = product_images_fr[noptid]
                  , set_id = img_part.setid
                  , opt_id = img_part.optid
                  , opt_rel = img_part.rel
                  , opt_ioption_active = getActiveOption(opt_rel, opt_id, set_id);
                if (opt_ioption_active && img_part.src != "") {
                    imgs_r.push(img_part);
                    var pos = img_part.pos.split(",")
                      , rp = _f.n(pos[0]) + _f.n(pos[2])
                      , bp = _f.n(pos[1]) + _f.n(pos[3]);
                    cnv_rect[2] = _f.n(cnv_rect[2]) < rp ? rp : _f.n(cnv_rect[2]),
                    cnv_rect[3] = _f.n(cnv_rect[3]) < bp ? bp : _f.n(cnv_rect[3])
                }
            }
            for (var ttl_cimg = imgs_r.length, ttl_r_cimg = 0, nimgs_r = [], mi2 = 0; mi2 < imgs_r.length; mi2++) {
                var img = _o.ce("img");
                img.crossOrigin = "Anonymous",
                img.onload = function() {
                    ttl_r_cimg++,
                    ttl_r_cimg == ttl_cimg && renderOptionImages(cnv_rect, imgs_r)
                }
                ,
                imgs_r[mi2].img = img,
                imgs_r[mi2].src.substr(0, 7) == "SPACE::" ? img.src = "https://cdn.inkybay.com/shopify/resources/1550007284798/option_images/" + imgs_r[mi2].src.substr(7) : img.src = "https://inkybay.com/shopify/out/bin/resources/1550007284798/option_images/" + imgs_r[mi2].src
            }
        }, renderOptionImages = function(cnv_rect, imgs_r) {
            var c = _o.ce("canvas");
            c.width = cnv_rect[2],
            c.height = cnv_rect[3];
            var x = c.getContext("2d"), swapped;
            do {
                swapped = !1;
                for (var i2 = 0; i2 < imgs_r.length - 1; i2++)
                    if (imgs_r[i2].zindex > imgs_r[i2 + 1].zindex) {
                        var temp = imgs_r[i2];
                        imgs_r[i2] = imgs_r[i2 + 1],
                        imgs_r[i2 + 1] = temp,
                        swapped = !0
                    }
            } while (swapped);
            for (var ii = 0; ii < imgs_r.length; ii++) {
                var part = imgs_r[ii]
                  , ipos = part.pos.split(",");
                x.drawImage(part.img, 0, 0, ipos[2], ipos[3], ipos[0], ipos[1], ipos[2], ipos[3])
            }
            SEL_EFL_IMG = c.toDataURL("image/png");
            var simg = product_render_image;
            if (simg.src = SEL_EFL_IMG,
            simg.srcset = SEL_EFL_IMG,
            simg.href = SEL_EFL_IMG,
            String(simg.tagName).toLowerCase() != "img" && (simg.style.backgroundImage = "url(" + SEL_EFL_IMG + ")",
            simg.style.backgroundSize = "100%"),
            product_render_image_zoom != "") {
                var simg = product_render_image_zoom;
                simg.src = SEL_EFL_IMG,
                simg.srcset = SEL_EFL_IMG,
                simg.href = SEL_EFL_IMG
            }
        }, product_images_fr = [], product_images_fr_r = [], product_images_fr_count = 0, set_product_image_part = function(part, rel, optid, setid) {
            {
                var pifr, noptid = "OPT" + optid;
                product_images_fr_r.indexOf(noptid) == -1 && (product_images_fr_r.push(noptid),
                product_images_fr_count++);
                var part_r = part.split("|~PRO_IMG_PART~|");
                part_r[0] == "" && (part_r = ["", "", ""]),
                product_images_fr[noptid] = {
                    src: part_r[0],
                    pos: part_r[1],
                    zindex: part_r[2],
                    optid,
                    setid,
                    rel
                },
                loadOptionProductParts()
            }
        }, getActiveOption = function(rel, opt_id, set_id) {
            for (var rel_active = !0; rel != "0_0"; ) {
                var rel_r = rel.split("_")
                  , relobj = _o.id("inkybay_opt_" + rel_r[0])
                  , relobji = _f.s(_o._a(relobj, "inkyindx"));
                rel_r[1] != relobji ? (rel_active = !1,
                rel = "0_0") : rel = _o._a(relobj, "option_relation")
            }
            return rel_active
        }, initializeUploadFiles = function() {
            for (var afs = _o.cl("INKYBAY_FILE_SELECT_INPUT"), fi2 = 0; fi2 < afs.length; fi2++)
                afs[fi2].addEventListener("change", inkybayFileSelect)
        }, inkybayFileSelect = function(e) {
            var finp = e.currentTarget
              , fsid = _f.s(e.currentTarget.id)
              , flabel = _o.id(fsid + "_LABEL")
              , flabelp = _o.id(fsid + "_LABEL_PERCENT")
              , flabela = _o.id(fsid + "_LABEL_AFTER")
              , flabelc = _o.id(fsid + "_LABEL_CHANGE")
              , fsicancel = _o.id(fsid + "_CANCEL")
              , fbar = _o.id(fsid + "_BAR")
              , fsid_r = fsid.split("INKYBAY_FILE_SELECT_INPUT_").join("").split("_")
              , fsetid = fsid_r[0]
              , foptid = fsid_r[1]
              , iobj = _o.id("inkybay_opt_" + foptid);
            flabel.style.display = "none",
            flabelp.style.display = "block",
            flabela.style.display = "none",
            fsicancel.style.display = "none",
            fbar.style.display = "block",
            fbar.style.width = "0%";
            var file = e.currentTarget.files[0]
              , data = new FormData;
            data.append("SelectedFile", file);
            var request = new XMLHttpRequest;
            request.onreadystatechange = function() {
                if (request.readyState == 4)
                    try {
                        var resp = JSON.parse(request.response);
                        iobj.inkyval = resp.data,
                        _o.a(iobj, "inkyval", resp.data);
                        var rq = _o._a(iobj, "inkyrequired") == "Y";
                        finp.style.display = rq ? "block" : "none",
                        fsicancel.style.display = rq ? "none" : "block",
                        flabel.style.display = "none",
                        flabelp.style.display = "none",
                        flabela.style.display = rq ? "none" : "block",
                        flabelc.style.display = rq ? "block" : "none",
                        recalculateOption()
                    } catch {
                        var resp = {
                            status: "error",
                            data: "Unknown error occurred: [" + request.responseText + "]"
                        };
                        alert(resp.data)
                    }
            }
            ,
            request.upload.addEventListener("progress", function(e2) {
                var pcent = Math.ceil(e2.loaded / e2.total * 100);
                flabelp.innerHTML = pcent + "%",
                fbar.style.width = pcent + "%"
            }, !1);
            var uplflnm = _o._a(iobj, "inkyval");
            request.open("POST", "https://inkybay.com/shopify/out/usr/post/upload_option_files.php?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798&delflnm=" + uplflnm),
            request.send(data)
        }, removeUploadedFile = function(sid, oid) {
            var fsid = "INKYBAY_FILE_SELECT_INPUT_" + sid + "_" + oid
              , fsicancel = _o.id(fsid + "_CANCEL")
              , iobj = _o.id("inkybay_opt_" + oid);
            fsicancel.style.display = "none";
            var uplflnm = _o._a(iobj, "inkyval");
            _o.a(iobj, "inkyval", ""),
            _r2 = new _ib_request,
            _r2.pl("https://inkybay.com/shopify/out/usr/post/delete_option_files.php?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798", "delflnm=" + uplflnm, onremoveUploadedFile, !0, fsid)
        }, onremoveUploadedFile = function(data, fsid) {
            var finp = _o.id(fsid)
              , flabel = _o.id(fsid + "_LABEL")
              , flabelp = _o.id(fsid + "_LABEL_PERCENT")
              , flabela = _o.id(fsid + "_LABEL_AFTER")
              , fsicancel = _o.id(fsid + "_CANCEL")
              , fbar = _o.id(fsid + "_BAR");
            finp.style.display = "block",
            flabel.style.display = "block",
            flabelp.style.display = "none",
            flabela.style.display = "none",
            fsicancel.style.display = "none",
            fbar.style.display = "none",
            fbar.style.width = "0%",
            recalculateOption()
        }, showInkyBayToolTip = function(id) {
            var ol = _o.id("INKYBAY_OPTION_HELP_ICON_TOOLTIP_" + id);
            ol.style.display = "inline"
        }, hideInkyBayToolTip = function(id) {
            var ol = _o.id("INKYBAY_OPTION_HELP_ICON_TOOLTIP_" + id);
            ol.style.display = "none"
        }, showSTooltip = function(obj) {
            var ttpobj = _o.id(obj.id.split("_lbl").join("_ttp"));
            ttpobj.style.display = ttpobj.innerHTML == "" ? "none" : "block"
        }, hideSTooltip = function(obj) {
            _o.id(obj.id.split("_lbl").join("_ttp")).style.display = "none"
        }, inkybay_option_price = [], inkybay_option_price_initialized = !1, initializePriceOptions = function(data) {
            var set_r = data.split("|:~OPTSET~:|");
            if (data != "")
                for (var si = 0; si < set_r.length; si++) {
                    for (var sets_r = set_r[si].split("|:~OPTSETID~:|"), opt_r = sets_r[1].split("|~OPT~|"), opt_price_r = [], oi = 0; oi < opt_r.length; oi++) {
                        var opts_r = opt_r[oi].split("|~OPTID~|");
                        opt_price_r[oi] = {
                            OPT_ID: opts_r[0],
                            PRICE_STR: opts_r[1]
                        }
                    }
                    inkybay_option_price[si] = {
                        SET_ID: sets_r[0],
                        OPT: opt_price_r
                    }
                }
            calculateOptionPrice(),
            inkybay_option_price_initialized = !0
        }, recalculateOption = function() {
            calculateOptionPrice()
        }, hasInkyBayOption = !1, calculateOptionPrice = function() {
            var hasInkyBayOptions2 = !1;
            hasInkyBayOption = !1;
            for (var set_price = 0, si = 0; si < inkybay_option_price.length; si++) {
                for (var set_id = inkybay_option_price[si].SET_ID, opt_r = inkybay_option_price[si].OPT, oi = 0; oi < opt_r.length; oi++) {
                    var opt_id = opt_r[oi].OPT_ID
                      , ps_r = opt_r[oi].PRICE_STR.split("|:~RELATION~:|")
                      , opt_option_active = getRelationalActive(ps_r[0], ps_r[1], opt_id, set_id);
                    if (opt_option_active) {
                        var opt_price = getOperationalPrice(ps_r[1], set_id, opt_id);
                        _o.id("inkybay_opt_price_" + opt_id).innerHTML = opt_price,
                        set_price += _f.n(opt_price),
                        hasInkyBayOptions2 = !0,
                        hasInkyBayOption = !0
                    }
                }
                _o.id("INKYBAY_OPTION_SET_PRICE_" + set_id).innerHTML = set_price
            }
            inkybayAllOptionPrice = _f.n(set_price),
            showInkybayProductCustomPrice(),
            hasInkyBayOptions2 && ibHideDefaultForm()
        }, getOperationalPrice = function(pstr2, set_id, opt_id) {
            var r_price = 0
              , obj = _o.id("inkybay_opt_" + opt_id)
              , objv = _f.s(obj.value)
              , objn = _f.n(obj.value);
            objn = objn ?? 0;
            for (var pstr_r = pstr2.split("|:~MORE_PRICE~:|"), pi = 0; pi < pstr_r.length; pi++) {
                var lstr_r = pstr_r[pi].split("|:~PRICE_TYPE~:|");
                switch (lstr_r[0]) {
                case "ANY_VALUE_PRICE":
                    r_price += objv.length ? _f.n(lstr_r[1]) : 0;
                    break;
                case "PER_CHAR_PRICE":
                    r_price += _f.n(lstr_r[1]) * objv.length;
                    break;
                case "MULTIPLY_PRICE":
                    r_price += _f.n(lstr_r[1]) * objn;
                    break;
                case "CUSTOM_SIZE_PRICE":
                    objv = _f.s(_o._a(obj, "inkyval"));
                    for (var ap_r = lstr_r[1].split("|:~ATTR~:|"), sprc = 0, ai = 0; ai < ap_r.length; ai++) {
                        var aps_r = ap_r[ai].split("|:~ATTR_PRICE~:|");
                        aps_r[0] == objv && (sprc = _f.n(aps_r[1]))
                    }
                    r_price += sprc;
                    break;
                case "PER_SQUARE_UNIT_PRICE":
                    if (objv = _f.s(_o._a(obj, "inkyval")),
                    _o.id("inkybay_option_custom_size_width_" + set_id + "_" + opt_id) && _o.id("inkybay_option_custom_size_width_" + set_id + "_" + opt_id).offsetParent !== null) {
                        let untCnv = {
                            cm: {
                                cm: 1,
                                in: .393700787401575,
                                ft: .032808398950131
                            },
                            in: {
                                in: 1,
                                cm: 2.54,
                                ft: .083333333333333
                            },
                            ft: {
                                ft: 1,
                                in: 12,
                                cm: 30.48
                            }
                        }
                          , calcUnit = lstr_r[1].split("_")[0]
                          , calcPrice = lstr_r[1].split("_")[1]
                          , uUnit = objv.split("_")[1]
                          , uMeasure = objv.split("_")[0].split("x")
                          , calcSqUnit = untCnv[uUnit][calcUnit]
                          , uSquare = uMeasure[0] * calcSqUnit * (uMeasure[1] * calcSqUnit);
                        r_price = calcPrice * uSquare
                    }
                    break;
                case "SINGLE_CHOICE_PRICE":
                    objv = _f.s(_o._a(obj, "inkyval"));
                    for (var ap_r = lstr_r[1].split("|:~ATTR~:|"), sprc = 0, ai = 0; ai < ap_r.length; ai++) {
                        var aps_r = ap_r[ai].split("|:~ATTR_PRICE~:|");
                        aps_r[0] == objv && (sprc = _f.n(aps_r[1]))
                    }
                    r_price += sprc;
                    break;
                case "MULTIPLE_CHOICE_PRICE":
                    objv = _f.s(_o._a(obj, "inkyval")),
                    objv_r = objv.split("|:~SAP~:|");
                    for (var ap_r = lstr_r[1].split("|:~ATTR~:|"), sprc = 0, ai = 0; ai < ap_r.length; ai++) {
                        var aps_r = ap_r[ai].split("|:~ATTR_PRICE~:|");
                        objv_r.indexOf(aps_r[0]) != -1 && (sprc += _f.n(aps_r[1]))
                    }
                    r_price += sprc;
                    break;
                case "FILE_VALUE_PRICE":
                    objv = _f.s(_o._a(obj, "inkyval")),
                    r_price += objv.length ? _f.n(lstr_r[1]) : 0;
                    break
                }
            }
            return r_price
        }, getRelationalActive = function(rel, pstr2, opt_id, set_id) {
            for (var rel_active = !0; rel != "0_0"; ) {
                var rel_r = rel.split("_")
                  , relobj = _o.id("inkybay_opt_" + rel_r[0])
                  , relobji = _f.s(_o._a(relobj, "inkyindx"));
                if (rel_r[1] != relobji)
                    rel_active = !1,
                    rel = "0_0";
                else
                    for (var osi = 0; osi < inkybay_option_price.length; osi++)
                        if (inkybay_option_price[osi].SET_ID == set_id)
                            for (var opt_r = inkybay_option_price[osi].OPT, ooi = 0; ooi < opt_r.length; ooi++)
                                opt_r[ooi].OPT_ID == rel_r[0] && (rel = opt_r[ooi].PRICE_STR.split("|:~RELATION~:|")[0])
            }
            return rel_active
        }, validateOptionField = function(optFld) {
            var opttype = _o._a(optFld, "type")
              , isValid = !0
              , optFldHdn = optFld.offsetParent === null;
            if (optFldHdn)
                return !0;
            switch (opttype) {
            case "number":
                var minP = _o._a(optFld, "min");
                minP = minP ?? 0;
                var maxP = _o._a(optFld, "max");
                maxP = maxP ?? 9999999999;
                var objV = _f.n(optFld.value);
                isValid = objV >= minP && objV <= maxP;
                var validExp = _o._a(optFld, "validation");
                if (validExp = validExp ?? "",
                validExp != "" && isValid) {
                    var re = new RegExp(validExp);
                    isValid = re.test(objV)
                }
                break;
            case "text":
                var objV = optFld.value
                  , validExp = _o._a(optFld, "validation");
                if (validExp = validExp ?? "",
                validExp != "" && isValid) {
                    var re = new RegExp(validExp,"g");
                    isValid = re.test(objV)
                }
                break;
            default:
                isValid = !0;
                break
            }
            var optcls = _o._a(optFld, "class");
            return optcls = optcls ?? "",
            optcls = optcls.split(" inkybay_opt_invalid_warning").join(""),
            optcls = optcls.split(" inkybay_opt_required_warning").join(""),
            isValid || (optcls = optcls + " inkybay_opt_invalid_warning"),
            _o.a(optFld, "class", optcls),
            isValid || (optFld.focus(),
            optFld.select()),
            isValid
        }, validateOptionFields = function() {
            for (var isAllvalidated = !0, si = 0; si < inkybay_option_price.length; si++)
                for (var set_id = inkybay_option_price[si].SET_ID, opt_r = inkybay_option_price[si].OPT, oi = 0; oi < opt_r.length; oi++) {
                    var opt_id = opt_r[oi].OPT_ID
                      , opt_field = _o.id("inkybay_opt_" + opt_id);
                    isAllvalidated = validateOptionField(opt_field) ? isAllvalidated : !1
                }
            return isAllvalidated
        }, inkybay_option_pack = [], inkybay_option_pack_price = 0, getInkybayOptionJsonData = function() {
            let jdata = packInkybayOptions("RETURN_JSON_DATA", "");
            return jdata = jdata.replace(/inkybay_ofile_start_(.*)_inkybay_ofile_end/i, "https://inkybay.com/shopify/out/bin/resources/1550007284798/option_files/$1"),
            jdata
        }, packInkybayOptions = function(fn, fnparams) {
            inkybay_option_pack = [];
            for (var hasInkyBayOptions2 = !1, allRequiredFulfill = !0, isAllvalidated = validateOptionFields(), set_price = 0, si = 0; si < inkybay_option_price.length; si++)
                for (var set_id = inkybay_option_price[si].SET_ID, opt_r = inkybay_option_price[si].OPT, oi = 0; oi < opt_r.length; oi++) {
                    var opt_id = opt_r[oi].OPT_ID
                      , ps_r = opt_r[oi].PRICE_STR.split("|:~RELATION~:|")
                      , opt_title_field = _o.id("inkybay_opt_title_" + opt_id)
                      , opt_field = _o.id("inkybay_opt_" + opt_id)
                      , opt_option_active = getRelationalActive(ps_r[0], ps_r[1], opt_id, set_id);
                    if (opt_option_active) {
                        var opt_option_required = _o._a(opt_field, "inkyrequired") == "Y"
                          , opt_price = getOperationalPrice(ps_r[1], set_id, opt_id)
                          , opt_inky_value = _o._a(opt_field, "inkyval");
                        opt_inky_value = opt_inky_value ?? opt_field.value;
                        var vnotg = opt_option_required && opt_inky_value.split("|:~VALUE_TITLE~:|")[0] == ""
                          , optcls = _o._a(opt_field, "class");
                        optcls = optcls ?? "",
                        optcls = optcls.split(" inkybay_opt_required_warning").join(""),
                        vnotg && (optcls = optcls + " inkybay_opt_required_warning"),
                        _o.a(opt_field, "class", optcls),
                        allRequiredFulfill = vnotg ? !1 : allRequiredFulfill;
                        var ttl = _o._a(opt_title_field, "ibopttl");
                        ttl = ttl == null ? opt_title_field.innerHTML : _o._a(opt_title_field, "ibopttl");
                        var opt_pack_r = {
                            id: opt_id,
                            title: ib_post_encode2(ttl),
                            opt_value: ib_post_encode2(opt_inky_value),
                            price: opt_price
                        };
                        inkybay_option_pack.push(opt_pack_r),
                        set_price += _f.n(opt_price),
                        hasInkyBayOptions2 = !0
                    }
                }
            if (allRequiredFulfill)
                if (isAllvalidated) {
                    var pack_optionPrice = calculateDiscountPerQuantity("OPTION", set_price)
                      , opt_pack_r = {
                        id: 0,
                        title: "TOTAL_OPTION_PRICE",
                        price: set_price,
                        discountedPrice: pack_optionPrice.calculatedPrice
                    };
                    if (inkybay_option_pack.push(opt_pack_r),
                    inkybay_option_pack_price = set_price,
                    _o.id("EFOLI_BUY_OPTION_BUTTON")) {
                        var bbtn = _o.id("EFOLI_BUY_OPTION_BUTTON");
                        bbtn.innerHTML = inkybayLoaderSvg + '<span style="opacity:0.2">' + bbtn.innerHTML + "</span>",
                        bbtn.style.pointerEvents = "none"
                    }
                    if (hasInkyBayOptions2) {
                        if (notPackingInkybayOptions = !1,
                        fn == "RETURN_JSON_DATA")
                            return JSON.stringify(inkybay_option_pack);
                        var packJsonString = JSON.stringify(inkybay_option_pack);
                        packJsonString = ib_post_encode2(packJsonString),
                        _r3 = new _ib_request,
                        _r3.pl("https://inkybay.com/shopify/out/usr/post/pack_option_data.php?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798", "packstr=" + packJsonString, afterpackInkybayOptions, !0, fn, fnparams)
                    } else
                        fn(0, fnparams)
                } else
                    _f.is(fnparams[2]) && (fnparams[2].style.pointerEvents = "all",
                    fnparams[2].innerHTML = fnparams[3]),
                    alert("Please enter valid data");
            else
                _f.is(fnparams[2]) && (fnparams[2].style.pointerEvents = "all",
                fnparams[2].innerHTML = fnparams[3]),
                alert("Please fill all required fields");
            return ""
        }, afterpackInkybayOptions = function(packid, oparams) {
            var fn = oparams[0];
            fn(packid, oparams[1])
        }, notPackingInkybayOptions = !0, packInkybayOptionsAndBuyBlank = function(loc2, lparam, btn, bstr) {
            notPackingInkybayOptions && inkybay_option_price_initialized ? packInkybayOptions(afterPackBuyBlank, [loc2, lparam, btn, bstr]) : (console.log("Wait For Load"),
            btn.style.pointerEvents = "all",
            btn.innerHTML = bstr)
        }, afterPackBuyBlank = function(packid, fparams) {
            _r4 = new _ib_request,
            _r4.pl(fparams[0], fparams[1] + "&inkybayoption=" + packid, afteraddToCartByBuyBlank)
        }, packInkybayOptionsAndGo = function(ploc, btn, bstr) {
            notPackingInkybayOptions && inkybay_option_price_initialized ? packInkybayOptions(afterpackInkybayOptionsAndGo, [ploc, "", btn, bstr]) : (console.log("Wait For Load"),
            btn.style.pointerEvents = "all",
            btn.innerHTML = bstr)
        }, afterpackInkybayOptionsAndGo = function(packid, fparams) {
            fparams[2].innerHTML = inkybayLoaderSvg + '<span style="opacity:0.2">' + fparams[2].innerHTML + "</span>",
            fparams[2].style.pointerEvents = "none",
            packid = packid + "|" + inkybay_option_pack_price;
            var nloc = fparams[0] + (fparams[0].indexOf("?") == -1 ? "?inkybayoption=" + packid : "&inkybayoption=" + packid);
            location = nloc
        }, addToCartByOption = function(packid, fparams) {
            if (_o.id("EFOLI_BUY_OPTION_BUTTON")) {
                var bbtn = _o.id("EFOLI_BUY_OPTION_BUTTON");
                bbtn.innerHTML = inkybayLoaderSvg + '<span style="opacity:0.2">' + bbtn.innerHTML + "</span>",
                bbtn.style.pointerEvents = "none"
            }
            var img_param = SEL_EFL_IMG != "" ? "&product_image=" + SEL_EFL_IMG : "";
            _r.pl("https://inkybay.com/shopify/out/usr/post/action/buy_option_to_cart_v600.php?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798", "product_id=" + proId + "&inkybayoption=" + packid + img_param, afteraddToCartByOption)
        }, afteraddToCartByOption = function(dta) {
            let dtr = dta.split("|*~CARTDATA~*|")
              , optiondata = "";
            dtr[2] && dtr[2] != "" && dtr[3] && dtr[3] != "" && (optiondata += "&items[0][properties][_inkybay_option_id]=" + dtr[2],
            optiondata += "&items[0][properties][_inkybay_option_data]=" + dtr[3]);
            let postData = "items[0][id]=" + dtr[1] + "&items[0][quantity]=" + _o.id("EFOLI_BUY_OPTION_QUANTITY").value + optiondata;
            inkybayFinalPostCurrentData = postData,
            _r.pl(window.location.origin + "/cart/add.js", postData, afterInkybayAddToCart)
        }, initializeButtons = function() {
            _o.id("EFOLI_BUY_OPTION_BUTTON").style.display = is_customizable ? "none" : "inline-block",
            _o.id("EFOLI_BUY_OPTION_QUANTITY").style.display = is_customizable ? "none" : "inline-block"
        }, cstm_str = is_customizable ? "y" : "n";
        _r1 = new _ib_request;
        var whstr = _s_WIN.w() + "x" + _s_WIN.h();
        _r1.pl("https://inkybay.com/shopify/out/usr/get/showProductOptions_v600.php?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798&wh=" + whstr, "proid=" + proId + "&customizable=" + cstm_str, onloadIBProductOption)
    } else {
        var inkybayCartPageLoadfn2 = function() {
            for (var divs = document.getElementsByTagName("div"), spans = document.getElementsByTagName("span"), pars = document.getElementsByTagName("p"), smalls = document.getElementsByTagName("small"), linkas = document.getElementsByTagName("a"), lists = document.getElementsByTagName("li"), dtt = document.getElementsByTagName("dt"), ddd = document.getElementsByTagName("dd"), elements_r = [divs, spans, pars, smalls, linkas, lists, dtt, ddd], onshowProductOptionsCart = function(odata, edata) {
                var cdiv2 = edata[0]
                  , oid2 = edata[1]
                  , astr = cdiv2.innerHTML;
                astr = astr.split('...<div class="inkybay_cart_hide" style="display:none">').join('<div class="inkybay_cart_display">'),
                astr = astr.split("inkybay_option_display_place_" + oid2).join(odata),
                astr = astr.split("&lt;br&gt;").join("<br>"),
                astr = astr.split("&lt;p&gt;").join(""),
                cdiv2.innerHTML = astr
            }, ei = 0; ei < elements_r.length; ei++)
                for (var elem = elements_r[ei], hi = 0; hi < elem.length; hi++) {
                    var hstr = String(elem[hi].innerHTML).split("<br>").join("");
                    if (hstr.indexOf("inkybay_option_id_") != -1 && hstr.indexOf("<") == -1) {
                        var cdiv = elem[hi]
                          , oid = hstr.split("inkybay_option_id_")[1];
                        oid = oid.split("|INKYSAP|")[0],
                        oid = oid.split(" ")[0],
                        oid = oid.split("<")[0],
                        oid = oid.split("&")[0],
                        oid = oid.replace(/(\r\n|\n|\r|\n\r)/gm, "");
                        var cartLineNo = getCartLineNo(cdiv);
                        cdiv.innerHTML = '...<div class="inkybay_cart_hide" style="display:none">inkybay_option_display_place_' + oid + "</div>",
                        _r5 = new _ib_request,
                        _r5.pl("https://inkybay.com/shopify/out/usr/get/showProductOptionsCart_v600.php?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798", "optid=" + oid + "&cartLineNo=" + cartLineNo, onshowProductOptionsCart, !0, cdiv, oid)
                    }
                }
        };
        inkybayCartPageLoadfn2()
    }
    var hasOptionWith = function(oType, oVendor, oTag, oHandle) {
        var has_option = !1
          , opt_r = OPTIONSET_RULE_STR.split("|:~RULE_SAP~:|");
        return opt_r.forEach(function(rl) {
            var rl_opt_r = rl.split("|:~RULE_VALUE~:|");
            switch (rl_opt_r[0]) {
            case "type":
                has_option = oType == rl_opt_r[1] ? !0 : has_option;
                break;
            case "vendor":
                has_option = oVendor == rl_opt_r[1] ? !0 : has_option;
                break;
            case "tags":
                has_option = oTag == rl_opt_r[1] ? !0 : has_option;
                break;
            case "handle":
                has_option = oHandle == rl_opt_r[1] ? !0 : has_option;
                break
            }
        }),
        has_option
    }
} else
    console.log("Inkybay - Faster Initialized");






//FOR Product page

    function getInkybayEmail(eaa,currentEmail) {       
        
        var divs= document.getElementsByTagName('div');
        var spans= document.getElementsByTagName('span');
        var pars= document.getElementsByTagName('p');
        var smalls= document.getElementsByTagName('small');
        var linkas= document.getElementsByTagName('a');
        var lists= document.getElementsByTagName('li');
        var dtt= document.getElementsByTagName('dt');
        var ddd= document.getElementsByTagName('dd');
        var elements_r = [divs,spans,pars,smalls,linkas,lists,dtt,ddd];
        
        
        var onshowProductOptionsCart = function(odata,edata)
        {
            var cdiv = edata[0];
            //console.log(cdiv);
            var oid = edata[1];
            //console.log(oid);
            var astr = cdiv.innerHTML;
            astr = astr.split('...<div class="inkybay_cart_hide" style="display:none">').join('<div class="inkybay_cart_display">');
            astr = astr.split('inkybay_option_display_place_'+oid).join(odata);
            cdiv.innerHTML = astr;

            const parser = new DOMParser();
            const doc = parser.parseFromString(astr, 'text/html');
            
            // Find all <div> elements
            const divs = doc.querySelectorAll('div');
            
            let email = null;
            
            divs.forEach(div => {
              const text = div.textContent?.trim();
              
              if (typeof text === 'string' && text.includes('Email address')) {
                const match = text.match(/Email address\s*:*\s*:\s*(.+)/);
                if (match && match[1]) {
                  email = match[1].trim();
                }
              }
            
              //console.log(text); // Optional: for debugging
            });
          console.log("currentEmail " + currentEmail);
          console.log("email "+ email);
            if (currentEmail !== email) {
               window.location.href = "/";
             }
            //console.log("Extracted email:", email);
          cdiv.innerHTML = email;
          const hiddenField = document.getElementById('inkybay-number');
          hiddenField.value = email;
           return email;

        };
        
        
        for(var ei=0; ei<elements_r.length; ei++)
        {
            var elem = elements_r[ei];
            for(var hi=0;hi<elem.length;hi++)
            {
                var hstr = String(elem[hi].innerHTML).split('<br>').join('');                
                if(hstr.indexOf('inkybay_option_id_') != -1 && hstr.indexOf('<') == -1)
                { 
                    var cdiv = elem[hi];                    
                    var oid = hstr.split('inkybay_option_id_')[1];
                    oid = oid.split('|INKYSAP|')[0];
                    oid = oid.split(' ')[0];
                    oid = oid.split('<')[0];
                    oid = oid.split('&')[0];
                    oid = oid.replace(/(\r\n|\n|\r|\n\r)/gm,"");
                    
                    var cartLineNo = getCartLineNo(cdiv);

                    cdiv.innerHTML = '...<div class="inkybay_cart_hide" style="display:none">inkybay_option_display_place_'+oid+'</div>';
                    
                    _r5 = new _ib_request();  
                    _r5.pl('https://inkybay.com/shopify/out/usr/get/showProductOptionsCart_v600.php?shop=meridianplanners-dev.myshopify.com&efltoken=1550007284798','optid='+oid+'&cartLineNo='+cartLineNo,onshowProductOptionsCart,true,cdiv,oid); 
                                        
                }
            }
        }
        
    };
